<template>
  <div class="sell">
      <div class="code_main" ref="product">
            <span :class="{'active':one}">① 选择产品</span>
            <span :class="{'install':!install}"></span>
            <span :class="{'active':two}">② 车辆所有人</span>
            <span v-if="install"></span>
            <span :class="{'active':three}" v-if="install">③ 安装信息</span>
            <span :class="{'install':!install}"></span>
            <span :class="{'active':four}">{{install?'④':'③'}} 完成</span>
      </div>
      <div class="productlist" v-if="one">
          <div class="product" :class="{activeborder:item.name == productNames}" v-for="(item,index) in productList" :key="index" @click="product(item)">
              <div class="product_top">
                  <span style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 70%;display: block;float: left;">{{item.name}}</span>
                  <span>选择产品</span>
              </div>
              <div class="product_year">
                  <p >保险年限:{{item.insuranceYears}}</p>
                  <p v-if="item.introduction" style="word-wrap: break-word; word-break: normal;display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 3;overflow: hidden;height: 60px;width:100%"> <span>简介:</span> {{item.introduction}}</p>
                  <p v-else style="word-wrap: break-word; word-break: normal;display: -webkit-box;-webkit-box-orient: vertical; -webkit-line-clamp: 3;overflow: hidden;height: 60px;">暂无简介</p>
              </div>
          </div>
          
      </div>
      <div class="carownperson" v-if="two">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
                <div class="a">
                   <p>车辆所有人</p>
                   <div class="left">
                        <el-form-item label="车辆所有人性质" prop="resource">
                             <el-radio-group v-model="ruleForm.resource" @change="carnature">
                                <el-radio-button label="1">个人</el-radio-button>
                                <el-radio-button label="2">企业</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                       <el-form-item label="名称" prop="name">
                            <el-input v-model="ruleForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="phone">
                            <el-input v-model.number="ruleForm.phone" maxlength="11"></el-input>
                        </el-form-item>
                   </div>
                   <div class="right">
                        <el-form-item label="证件类型" prop="paperwork">
                             <el-radio-group v-model="ruleForm.paperwork" v-if="toggle" @change="paperworktype">
                                <el-radio-button label="1">身份证</el-radio-button>
                                <el-radio-button label="2">护照</el-radio-button>
                                <el-radio-button label="4">其他</el-radio-button>
                            </el-radio-group>
                            <el-radio-group v-model="ruleForm.paperwork" v-if="!toggle" @change="paperworktype">
                                <el-radio-button label="3">统一社会信用代码证</el-radio-button>
                                <el-radio-button label="4">其他</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <div>
                            <!-- 身份证 -->
                            <el-form-item label="证件号码(身份证)" prop="number" v-if="a">
                                <el-input v-model="ruleForm.number" maxlength="18"></el-input>
                            </el-form-item>
                            <!-- 护照 -->
                            <el-form-item label="证件号码(护照)" prop="numberpassport" v-if="b">
                                <el-input v-model="ruleForm.numberpassport" minlength="8" maxlength="9"></el-input>
                            </el-form-item>
                            <!-- 统一社会征信代码 -->
                            <el-form-item label="证件号码(征信)" prop="numbercredit" v-if="c">
                                <el-input v-model="ruleForm.numbercredit" maxlength="18"></el-input>
                            </el-form-item>
                            <!-- 其他 -->
                            <el-form-item label="证件号码(其他)" prop="numberother" v-if="d">
                                <el-input v-model="ruleForm.numberother" maxlength="18"></el-input>
                            </el-form-item>  
                        </div>
                       
                        <el-form-item label="证件详细地址" prop="address">
                            <el-input v-model="ruleForm.address"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="常住详细地址" prop="address1">
                            <el-input v-model="ruleForm.address1"></el-input>
                        </el-form-item> -->
                   </div>
                </div>
                <div class="a">
                   <p>车辆信息</p>
                   <div class="left">
                        <el-form-item label="车辆类别" prop="cartype">
                             <el-radio-group v-model="ruleForm.cartype">
                                <el-radio-button label="1">新车</el-radio-button>
                                <el-radio-button label="2">二手车</el-radio-button>
                                <el-radio-button label="3">旧车</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="车辆类型" prop="cartype1"> 
                            <el-radio-group v-model="ruleForm.cartype1"> 
                            <el-radio label="1">乘用车</el-radio>         
                            <el-radio label="2">商用车</el-radio>      
                            </el-radio-group>
                        </el-form-item>
                       <el-form-item label="发动机号" prop="number1">
                            <el-input v-model="ruleForm.number1"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="车牌号">
                            <el-input v-model="ruleForm.number2"></el-input>
                        </el-form-item> -->
                        <el-form-item label="初始购车日期" prop="date1">
                                <el-date-picker type="date" placeholder="选择日期"  @change="selectdate" v-model="ruleForm.date1" style="width: 100%;"
                                :picker-options="pickerBeginDateBefore"
                                class="picker-style"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="购买发票价格" prop="money">
                            <el-input v-model="ruleForm.money"></el-input>
                        </el-form-item>
                         <el-form-item label="贷款合同号" prop="loannumber" v-if="flagbuycartype">
                            <el-input v-model="ruleForm.loannumber"></el-input>
                        </el-form-item>
                   </div>
                   <div class="right">
                        <el-form-item label="车辆型号" required>
                            <el-col :span="11">
                                <el-form-item prop="data1">
                                    <el-input v-model="ruleForm.data1" placeholder="请输入车辆品牌"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :span="2" >-</el-col>
                            <el-col :span="11">
                                <el-form-item prop="data2">
                                <el-input v-model="ruleForm.data2" placeholder="请输入车辆车型" maxlength="20"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                       <el-form-item label="车辆排量">
                            <el-input v-model="ruleForm.amount"></el-input>
                        </el-form-item>
                        <el-form-item label="车架号" prop="frame">
                            <el-input v-model="ruleForm.frame" maxlength="17"></el-input>
                        </el-form-item>
                        <el-form-item label="购车类型" prop="buytype" >
                            <el-radio-group v-model="ruleForm.buytype" @change="buytype">
                            <el-radio label="1">贷款</el-radio>
                            <el-radio label="2">全款</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="原厂质保" required v-if="flagsafe">
                            <el-col :span="4">
                                <el-form-item prop="warranty">
                                <el-input v-model="ruleForm.warranty" @blur="selectinput"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :span="1">年</el-col>
                            <el-col :span="4">
                                <el-form-item prop="warranty1">
                                    <el-input v-model="ruleForm.warranty1"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col class="line" :span="3">万公里</el-col>
                        </el-form-item>
                        <el-form-item label="贷款金额" prop="loan" v-if="flagbuycartype">
                            <el-input v-model="ruleForm.loan"></el-input>
                        </el-form-item>
                        
                   </div>
                   <div class="peizhi" style="float:left;width:100%">
                       <!-- 车辆必填 文本-->
                       <!-- prop="dynamic" -->
                       <div class="b"  v-for="(item,index) in ruleForm.list1" :key="item.title">
                            <el-form-item   :label="item.title" :prop="`list1.${index}.datas`" :rules=" { required: true,message:'必填', trigger: 'blur' }">
                                    <el-input v-model="item.datas" ></el-input>
                            </el-form-item>   
                        </div>
                        <!-- radiorequier 车辆必填单选-->
                        <div class="b" v-for="(item,index) in ruleForm.list4" :key="item.title">
                            <el-form-item :label="item.title" :prop="`list4.${index}.radios`" :rules=" { required: true,message:'必选', trigger: 'blur' }">
                                <el-radio-group v-model="item.radios">
                                <el-radio v-for="(items,index) in item.options?item.options.split('/t'):''" :key="index" :label="items">{{items}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <!-- 车辆非必填 -->
                        <div class="b" v-for="(item) in ruleForm.list2" :key="item.title" >
                            <el-form-item :label="item.title">
                                    <el-input v-model="item.datas"></el-input>
                            </el-form-item>
                        </div>
                        <div class="b" v-for="(item) in ruleForm.list5" :key="item.title">
                            <el-form-item :label="item.title" >
                                <el-radio-group v-model="item.radios">
                                <el-radio v-for="(items,index) in item.options?item.options.split('/t'):''" :key="index" :label="items">{{items}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                   </div>
                </div>
                <div class="a">
                   <p>金融公司</p>
                   <div class="left">
                       <el-form-item label="金融公司" prop="companyvalue" v-if="flagbuycartype">
                            <!-- <span>{{financeCompany}}</span> -->
                            <el-select v-model="ruleForm.companyvalue" @change="selectcompany" placeholder="请选择金融公司">
                                <el-option
                                v-for="item in companyoptions"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                   </div>
                   <div class="right">
                       <el-form-item label="第一受益人">
                            <el-input v-model="ruleForm.person"></el-input>
                        </el-form-item>
                   </div>
                </div>
                <div class="a">
                   <p>保单信息</p>
                   <div class="left">
                       <el-form-item label="产品名称">
                            <span>{{baoxianname}}</span>
                        </el-form-item>
                        <el-form-item label="保险年限" prop="years">
                            <el-radio-group v-model="ruleForm.years">
                            <el-radio v-for="(item,index) in yearArrs" :key="index" :label="item">{{item}}年</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="备注信息" prop="desc">
                            <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                        </el-form-item>
                        <el-button  v-preventReClick type="primary" style="margin-left:130px" @click="money()">试算保费</el-button>
                        <span style="margin-left:30px" v-if="moneysflag">保费金额:{{moneys}}元</span>
                   </div>
                   <div class="right">
                       <el-form-item label="生效日期">
                            <el-input v-model="effectivedate" placeholder="例:2020-08-22" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="服务费" v-if="templateflag" prop="servicemoney">
                            <el-input v-model="ruleForm.servicemoney" placeholder="" ></el-input>
                        </el-form-item>
                   </div>
                </div>
                <div class="a">
                    <p>其他信息</p>
                    <div class="b" v-for="(item,index) in ruleForm.list" :key="item.title" >
                         <el-form-item :label="item.title" :prop="`list.${index}.datas`" :rules=" { required: true,message:'必填', trigger: 'blur' }">
                                <el-input v-model="item.datas"></el-input>
                        </el-form-item>
                    </div>
                    <div class="b" v-for="(item,index) in ruleForm.list6" :key="item.title">
                            <el-form-item  :label="item.title"  :prop="`list6.${index}.radios`" :rules=" { required: true,message:'必选', trigger: 'blur' }">
                                <el-radio-group v-model="item.radios">
                                <el-radio v-for="(items,index) in item.options?item.options.split('/t'):''" :key="index" :label="items">{{items}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    <div class="b" v-for="(item) in ruleForm.list3" :key="item.title" >
                         <el-form-item :label="item.title" >
                                <el-input v-model="item.datas"></el-input>
                        </el-form-item>
                    </div>
                    <div class="b" v-for="(item) in ruleForm.list7" :key="item.title">
                            <el-form-item :label="item.title">
                                <el-radio-group v-model="item.radios">
                                <el-radio v-for="(items,index) in item.options?item.options.split('/t'):''" :key="index" :label="items">{{items}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                </div>   
                <div class="a">
                    <p>影印件上传</p>
                    <div class="left">
                        <!-- prop="zheng" -->
                        <el-form-item label="身份证正面" prop="zheng">
                            <el-upload
                            :class="{hide:hideUpload}"
                            action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                            :file-list="fileList"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-preview="handlePictureCardPreview"
                            :on-change="changeImg"
                            :on-success="imgsuccess"
                            :on-remove="handleRemove">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="购车发票">
                            <el-upload
                            :class="{hide:hideUploadinvoice}"
                            action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                             :file-list="fileList2"
                             accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-preview="handlePictureCardPreviewinvoice"
                            :on-change="changeImginvoice"
                            :on-success="imgsuccessinvoice"
                            :on-remove="handleRemoveinvoice">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisibleinvoice"> 
                            <img width="100%" :src="dialogImageUrlinvoice" alt="">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="行驶证" >
                            <el-upload
                            :class="{hide:hideUploadply}"
                            action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                             :file-list="fileList4"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-preview="handlePictureCardPreviewply"
                            :on-change="changeImgply"
                            :on-success="imgsuccessply"
                            :on-remove="handleRemoveply">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisibleply">
                            <img width="100%" :src="dialogImageUrlply" alt="">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="里程数" >
                            <el-upload
                            :class="{hide:hideUploadmileage}"
                             action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreviewmileage"
                            :on-change="changeImgmileage"
                             :file-list="fileList6"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-success="imgsuccessmileage"
                            :on-remove="handleRemovemileage">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisiblemileage">
                            <img width="100%" :src="dialogImageUrlmileage" alt="">
                            </el-dialog>
                        </el-form-item>  
                    </div>
                    <div class="right">
                        <!-- prop="fan" -->
                        <el-form-item label="身份证反面" prop="fan">
                            <el-upload
                            :class="{hide:hideUploadfan}"
                             action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                             :file-list="fileList1"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-preview="handlePictureCardPreviewfan"
                            :on-change="changeImgfan"
                            :on-success="imgsuccessfan"
                            :on-remove="handleRemovefan">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisiblefan">
                            <img width="100%" :src="dialogImageUrlfan" alt="">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="贷款合同">
                            <el-upload
                            :class="{hide:hideUploadloan}"
                             action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                             :file-list="fileList3"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-preview="handlePictureCardPreviewloan"
                            :on-change="changeImgloan"
                             :on-success="imgsuccessloan"
                            :on-remove="handleRemoveloan">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisibleloan">
                            <img width="100%" :src="dialogImageUrlloan" alt="">
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="合格证">
                            <el-upload
                            :class="{hide:hideUploadqualified}"
                            action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                             :file-list="fileList5"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-preview="handlePictureCardPreviewqualified"
                            :on-change="changeImgqualified"
                             :on-success="imgsuccessqualified"
                            :on-remove="handleRemovequalified">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisiblequalified">
                            <img width="100%" :src="dialogImageUrlqualified" alt="">
                            </el-dialog>
                        </el-form-item>
                        <!-- 驾驶证 -->
                        <el-form-item label="驾驶证" >
                            <el-upload
                            :class="{hide:hideUploaddriveLicence}"
                             action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreviewdriveLicence"
                            :on-change="changeImgdriveLicence"
                             :file-list="fileList8"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-success="imgsuccessdriveLicence"
                            :on-remove="handleRemovedriveLicence">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisibledriveLicence">
                            <img width="100%" :src="dialogImageUrldriveLicence" alt="">
                            </el-dialog>
                        </el-form-item>
                    </div>
                    <div class="other" style="float: left;width: 100%;">
                        <el-form-item label="其他" >
                            <el-upload
                            :class="{hide:hideUploadother}"
                             action="http://1.95.5.134:8088/file/uploadOssFile"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreviewother"
                            :on-change="changeImgother"
                             :file-list="fileList7"
                            accept=".jpeg,.png,.jpg,.PNG,.JPG,.JPEG"
                            :on-success="imgsuccessother"
                            :on-remove="handleRemoveother">
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisibleother">
                            <img width="100%" :src="dialogImageUrlother" alt="">
                            </el-dialog>
                        </el-form-item>
                    </div>
                </div>

                <div class="a">
                    <el-form-item>
                        <el-button  v-preventReClick v-if="previous" @click="back()"  >上一步</el-button>
                        <el-button  v-preventReClick type="primary" @click="submitForm()"  >{{install?'下一步':'完成'}}</el-button>
                        <el-button  v-preventReClick type="primary" @click="savecaogao()" v-if="saveDraft"  >保存草稿</el-button>
                    </el-form-item>
                </div>
              </el-form>

      </div>
      <div class="installinfo" v-if="three">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <div class="a">
                  <p>产品包含设备</p>
                  <el-form-item label="选择设备" prop="device">
                      <el-radio-group v-model="ruleForm.device" @change="deviceselect">
                        <el-radio v-for="(item,index) in deviceList" :key="index" :label="item.deviceName"></el-radio>
                      </el-radio-group>
                  </el-form-item> 
                  <el-form-item label="设备编码" prop="devicenum">
                      <el-input v-model="ruleForm.devicenum" style="width:30%" @blur="verifiycode"></el-input>
                  </el-form-item>
              </div>
              <div class="a">
                  <p>安装方</p>
                  <el-form-item label="安装方" >
                      店内安装
                  </el-form-item>
              </div>
              <div class="a">
                  <p>安装信息</p>
                  <el-form-item label="安装时间">
                    <el-col :span="11">
                    <el-date-picker @change="selectdates" type="date" placeholder="选择日期" v-model="ruleForm.datedevice" style="width: 70%;"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                </el-form-item>
              </div>
              <div class="a">
                  <el-form-item>
                        <el-button  v-preventReClick @click="back2()">上一步</el-button>
                        <el-button  v-preventReClick type="primary" @click="submitForm2()">完成</el-button>
                        <el-button  v-preventReClick type="primary" @click="savedraft()" v-if="saveDraft">保存草稿</el-button>
                    </el-form-item>
              </div>
          </el-form>
      </div>
      <div class="success" v-if="four">
          <img src="../assets/success.png" alt="">
          <p>录入信息成功</p>
          <el-button  v-preventReClick type="primary" @click="carryon">继续购买保险产品</el-button>
      </div>
  </div>
</template>

<script>

// remove getdevices
import {getproduct,customizeinfo,saveDrafts,saveFacility,verifyFacility,trialPremium,deleteCode,queryShopProDev,isCharge} from '../axios/api'
export default {
        
    computed:{
        dynamicValidateForm(){
            return {
                ruleForm:this.domains
            }
        }
    },
    data(){
        var checkProv = function (val) {
                var pattern = /^[1-9][0-9]/;
                var provs = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门"};
                if(pattern.test(val)) {
                    if(provs[val]) {
                        return true;
                    }
                }
                return false;
        }
        var checkDate = function (val) {
            var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
            if(pattern.test(val)) {
                var year = val.substring(0, 4);
                var month = val.substring(4, 6);
                var date = val.substring(6, 8);
                var date2 = new Date(year+"-"+month+"-"+date);
                if(date2 && date2.getMonth() == (parseInt(month) - 1)) {
                    return true;
                }
            }
            return false;
        }
        var checkCode = function (val) {
            var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
            var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
            var code = val.substring(17);
            if(p.test(val)) {
                var sum = 0;
                for(var i=0;i<17;i++) {
                    sum += val[i]*factor[i];
                }
                if(parity[sum % 11] == code.toUpperCase()) {
                    return true;
                }
            }
            return false;
        }
        var checkID = function (val) {
            if(checkCode(val)) {
                var date = val.substring(6,14);
                if(checkDate(date)) {
                    if(checkProv(val.substring(0,2))) {
                        return true;
                    }
                }
            }
            return false;
        }
        var validatorphone = (rule, value, callback) =>{
            console.log(rule, value, callback)
            if(value == ''){
                return callback(new Error('请填写手机号码'));
            }else if(!(/^1[3456789]\d{9}$/.test(value))){
               return callback(new Error('手机号码格式不正确'))
               
            }else{
                callback()
            }
        }
        var validatornumber = (rule, value, callback) =>{
            console.log(rule, value, callback)
            if(value == ''){
                return callback(new Error('请填写证件号码'))
            // }else if(!(/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value))){
            }else if(!checkID(value)){
               return callback(new Error('证件号码格式不正确'));
            }else{
                callback()
            }
        }
        var validatornumber1 = (rule, value, callback) =>{
            console.log(rule, value, callback)
            if(value == ''){
                return callback(new Error('请输入发动机号'));
            }else if(!(/^[A-Za-z0-9]+$/.test(value))){
               return callback(new Error('请输入数字跟字母'));
            }else{
                callback()
            }
        }
        var validatornumber2 = (rule, value, callback) =>{
            console.log(rule, value, callback)
            if(value == ''){
                return callback(new Error('请输入车架号'));
            }else if(!(/^[A-Za-z0-9]+$/.test(value))){
               return callback(new Error('请输入数字跟字母'));
            }else if(value.length < 17 || value.length > 17){
                 return callback(new Error('请输入17位正确的车架号'));
            }else{
                callback()
            }
        }
        var validatormoney = (rule, value, callback) =>{
            if(value == ''){
                return callback(new Error('请输入购车发票价格'));
            }else if(!(/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/).test(value)){
               return callback(new Error('请输入正确的发票价格'));
            }else{
                callback()
            }
        }        
        var validatorloan = (rule, value, callback) =>{
            if(value == ''){
                return callback(new Error('请输入贷款金额'));
            }else if(!(/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/).test(value)){
               return callback(new Error('请输入正确的贷款金额'));
            }else{
                callback()
            }
        }
        var validatorzheng = (rule, value, callback) =>{
            console.log(rule, value, callback,this.dialogImageUrl)
            value = this.dialogImageUrl
            if(value == ''){
                return callback(new Error('请上传身份证正面'));
            }else{
                callback()
            }
        }
        var validatorfan = (rule, value, callback) =>{
            console.log(rule, value, callback,this.dialogImageUrlfan)
            value = this.dialogImageUrlfan
            if(value == ''){
                return callback(new Error('请上传身份证反面'));
            }else{
                callback()
            }
        }
        // var validatorinvoice = (rule, value, callback) =>{
        //     console.log(rule, value, callback,this.dialogImageUrlinvoice)
        //     value = this.dialogImageUrlinvoice
        //     if(value == ''){
        //         return callback(new Error('请上传购车发票'));
        //     }else{
        //         callback()
        //     }
        // }
        
        var validatornumberpassport = (rule, value, callback) =>{
            console.log(rule, value, callback)
            if(value == ''){
                return callback(new Error('请填写证件号码护照')) 
            }else if(value.length < 8 || value.length > 9){
                 return callback(new Error('证件号码格式不正确'));
            }else if(!(/^[A-Za-z0-9]+$/.test(value))){
               return callback(new Error('证件号码格式不正确'));
            }else{
                callback()
            }
        }
        var validatornumbercredit = (rule, value, callback) =>{
            console.log(rule, value, callback)
            if(value == ''){
                return callback(new Error('请填写证件号码征信'))
            }else if(value.length !== 18){
                 return callback(new Error('证件号码格式不正确'));
            }else if(!(/^[A-Za-z0-9]+$/.test(value))){
               return callback(new Error('证件号码格式不正确'));
            }else{
                callback()
            }
        }
        var validatorservice = (rule, value, callback) =>{
            console.log(rule, value, callback)
            if(!(/^(\d+\.?)?\d{0,2}$/.test(value))){
               return callback(new Error('服务费格式不正确'));
            }else{
                callback()
            }
        }
        
        return{
             scrollTop: 0,
            previous:true,
            productNames:'',
             one:true,
             two:false,
             three:false,
             four:false,
            //  有没有安装信息
            install:false,
            ruleForm: {
                name: '',
                phone:'',
                number:'',
                address:'',
                address1:'',
                cartype:'1',
                cartype1:'',
                // region: '',
                date1: '',
                // date2: '',
                // delivery: false,
                // type: [],
                resource: '1',
                paperwork:'1' ,
                money:'',
                number1:'',
                number2:'',
                data1:'',
                data2:'',
                frame:'',
                loan:'',
                buytype:'',
                warranty:'',
                warranty1:'',
                person:'',
                years:'',
                desc: '',
                loannumber:'',
                amount:'',
                numberpassport:'',
                numbercredit:'',
                numberother:'',
                // 服务费
                servicemoney:'',
                companyvalue:'',
                // 其他模块必填(文本)
                list:[],
                // 车辆模块必填(单选)
                list1:[],
                // 车辆模块非必填(文本)
                list2:[],
                // // 其他信息非必填(单选)
                list3:[],
                list4:[],
                list5:[],
                list6:[],
                list7:[],
                device:'',
                devicenum:'',
                datedevice:''
            },
            rules: {
                device:[
                   { required: true, message: '请选择设备', trigger: 'change' }  
                ],
                devicenum:[
                    { required: true, message: ' 请输入设备编码', trigger: 'blur' }  
                ],
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                phone: [
                    { validator:validatorphone,required: true, trigger: 'blur' },
                    { type: 'number', message: '电话号码必须为数字值',trigger: 'blur' }
                ],
                number: [
                    { validator:validatornumber,required: true, trigger: 'blur' },
                    // { type: 'number', message: '证件号码必须为数字值',trigger: 'blur' }
                ],
                numberpassport:[
                     { validator:validatornumberpassport,required: true, trigger: 'blur' },
                ],
                
                numbercredit:[
                     { validator:validatornumbercredit,required: true, trigger: 'blur' },
                ],
                address: [
                    { required: true, message: '请输入证件详细地址', trigger: 'blur' },
                ],
                address1: [
                    { required: true, message: '请输入常住详细地址', trigger: 'blur' },
                ],
                cartype:[
                    { required: true, message: '请选择车辆类别', trigger: 'change' }
                ],
                money: [
                    { validator:validatormoney,required: true, trigger: 'blur' }
                ],
                number1: [
                    { validator:validatornumber1,required: true,  trigger: 'blur' },
                    { min: 6, max: 8, message: '长度在 6 到 8 个字符', trigger: 'blur' }
                ],
                date1: [
                    { type: 'date', required: true, message: '请选择初始购车日期', trigger: 'change' }
                ],
                loannumber:[
                     { required: true, message: '请输入贷款合同号', trigger: 'blur' },
                ],
                data1: [
                    { required: true, message: '请输入车辆品牌', trigger: 'blur' },
                ],
                data2: [
                    { required: true, message: '请输入车辆车型', trigger: 'blur' },
                ],
                warranty: [
                    { required: true, message: '请输入质保年数', trigger: 'blur' },
                ],
                warranty1: [
                    { required: true, message: '请输入公里数', trigger: 'blur' },
                ],
                resource: [
                    { required: true, message: '请选择车辆所有人性质', trigger: 'change' }
                ],
                buytype :[
                    { required: true, message: '请选择购车类型', trigger: 'change' }
                ],
                paperwork: [
                    { required: true, message: '请选择证件类型', trigger: 'change' }
                ],
                loan: [
                    { validator:validatorloan,required: true, trigger: 'blur' }
                ],
                frame:[
                    {validator:validatornumber2, required: true, trigger: 'blur' },
                ],
                years:[
                    { required: true, message: '请选择保险年限', trigger: 'change' } 
                ],
                zheng:[
                    { validator:validatorzheng,required: true, trigger: 'change' } 
                ],
                fan:[
                    { validator:validatorfan,required: true, trigger: 'change' } 
                ],
                cartype1:[
                    { required: true, message: '请选择车辆类型', trigger: 'change' } 
                ],
                companyvalue:[
                    { required: true, message: '请选择金融公司', trigger: 'change' } 
                ],
                numberother:[
                     { required: true,message: '请填写证件其他号码', trigger: 'blur' },
                ],
                servicemoney:[
                    {
                       validator:validatorservice,trigger:'blur',
                    }
                ]
            },
            pickerBeginDateBefore: {
                disabledDate(time) {
                return time.getTime() > Date.now();
                }
            },
            pickerVal: [],
            // 身份证正面
            dialogImageUrl: '',
            dialogVisible: false,
            hideUpload: false,
            limitCount:1,
            // 身份证反面
            dialogImageUrlfan: '',
            dialogVisiblefan: false,
            hideUploadfan: false,
            limitCountfan:1,
            // 购车发票
            dialogImageUrlinvoice: '',
            dialogVisibleinvoice: false,
            hideUploadinvoice: false,
            limitCountinvoice:1,
            // 贷款合同
            dialogImageUrlloan: '',
            dialogVisibleloan: false,
            hideUploadloan: false,
            limitCountloan:1,
            // 行驶证
            dialogImageUrlply: '',
            dialogVisibleply: false,
            hideUploadply: false,
            limitCountply:1,
            // 合格证  qualified
            dialogImageUrlqualified: '',
            dialogVisiblequalified: false,
            hideUploadqualified: false,
            limitCountqualified:1,
            // 里程数 mileage
            dialogImageUrlmileage: '',
            dialogVisiblemileage: false,
            hideUploadmileage: false,
            limitCountmileage:1,
            // 驾驶证
            hideUploaddriveLicence:false,
            dialogImageUrldriveLicence:'',
            dialogVisibledriveLicence:false,
            limitCountdriveLicence:1,
            // 其他 other
            dialogImageUrlother: '',
            dialogVisibleother: false,
            hideUploadother: false,
            limitCountother:6,
            // 其他模块必填(文本)
            list:[],
            // 车辆模块必填(单选)
            list1:[],
            // 车辆模块非必填(文本)
            list2:[],
            // 其他信息非必填(单选)
            list3:[],
            list4:[],
            list5:[],
            list6:[],
            list7:[],
            ruleFormdevices:{
                device:'',
                devicenum:'',
                date1:''
            },
            rulesdevice:{
                device:[
                   { required: true, message: '请选择设备', trigger: 'change' }  
                ],
                devicenum:[
                    { required: true, message: ' 请输入设备编码', trigger: 'blur' }  
                ]
            },
            productList:[],
            toggle:true,
            financeCompany:'',
            baoxianname:'',
            productId:'',
            effectivedate:'',
            insuranceExtensionType:0,
            buycardate:'',
            yearsnum:0,
            Lists:[],
            extendFieldList:[],
            state:2,
            deviceList:[],
            orderid:'',
            flag:false,
            draftstate:false,
            draftstate2:false,
            dialogImageUrls:'',
            dialogImageUrlfans:'',
            dialogImageUrlinvoices:'',
            dialogImageUrlloans:'',
            dialogImageUrlplys:'',
             dialogImageUrlqualifieds:'',
            dialogImageUrlmileages:'',
            dialogImageUrldriveLicences:'',
            dialogImageUrlothers:[],
            yearArrs:[],
            codes:'',
            statedraft:'',
            draftid:'',
            codestr:'',
            flagbuycartype:false,
            flagsafe:false,
            fileList:[],
            fileList1:[],
            fileList2:[],
            fileList3:[],
            fileList4:[],
            fileList5:[],
            fileList6:[],
            fileList7:[],
            fileList8:[],
            dateinit:'',
            moneys:'',
            moneysflag:false,
            a:true,
            b:false,
            c:false,
            d:false,
            saveDraft:true,
            deviceid:'',
            oneflag:0,
            devicevalue:'',
            companyoptions:[],
            leizhiList:{},
            templateflag:false,
            // templateId:''
            premium:'',
            buycarddp:0,
            loanht:0,
            paperwork:0,
            hegezheng:0,
            xingshizheng:0,
            lichengshu:0,
            qita:0,
            isChargemenu:'',
            draft:false,
            failfinsh:false
        }
    },
    created(){
        
        console.log(this.$route.params,1111111)
        if(this.$route.params.safefails){
                        this.one = false
                        this.two = true
                        this.three = false
                        this.four = false
                        this.saveDraft = false
                        this.previous = false
                        if(this.$route.params.all.buyCarType == '1'){
                            this.companyoptions = this.$route.params.all.productFinancialCompany.split(',')
                        }else{
                            this.companyoptions = this.$route.params.all.productFinancialCompany.split(',')
                        }
                        this.failfinsh = this.$route.params.failfinsh
                        this.failorder()
        }
        if(this.$route.params.modify){
            this.previous = false
        }
        if(this.$route.params.all){
            // if(this.$route.params.all.templateId){
            //     if(this.$route.params.all.templateId.split(',').indexOf('2') !== -1 || this.$route.params.all.templateId.split(',').indexOf('6') !== -1 || this.$route.params.all.templateId.split(',').indexOf('10') !== -1 || this.$route.params.all.templateId.split(',').indexOf('11') !== -1|| this.$route.params.all.templateId.split(',').indexOf('12') !== -1|| this.$route.params.all.templateId.split(',').indexOf('14') !== -1){
            //         this.templateflag = true
            //     }else{
            //         this.templateflag = false
            //     }
            // }
            if(this.$route.params.all.templateId){
                let charge = this.$route.params.all.isCharge.split(',')
                let template = this.$route.params.all.templateId.split(',')
                console.log(charge,template)
                let aindex = charge.map(items=>{
                       return template.indexOf(items)
                })
                console.log(aindex)
                let bindex = aindex.map(item=>{
                    console.log(item)
                    if(item !== -1){
                        return item
                    }
                })
                console.log(bindex)
                let cindex = []
                bindex.forEach(item=>{
                    if(item !== undefined){
                        cindex.push(item)
                    }
                })
                console.log(cindex)
                if(cindex.length > 0){
                     this.templateflag = true
                }else{
                    this.templateflag = false
                }
            }    
            this.productNames = this.$route.params.all.productName
                   this.ruleForm.resource = this.$route.params.all.carNature
                   this.ruleForm.paperwork = this.$route.params.all.papers
                   this.ruleForm.name = this.$route.params.all.name
                   console.log(this.$route.params.all.papers)
                   if(this.$route.params.all.papers == 1){
                       this.a = true
                       this.b = false
                       this.c = false
                       this.d = false
                       this.ruleForm.number = this.$route.params.all.number
                   }else if(this.$route.params.all.papers == 2){
                       this.a = false
                       this.b = true
                       this.c = false
                       this.d = false
                       this.ruleForm.numberpassport = this.$route.params.all.number
                   }else if(this.$route.params.all.papers == 3){
                       this.a = false
                       this.b = false
                       this.c = true
                       this.d = false
                       this.ruleForm.numbercredit = this.$route.params.all.number
                   }else if(this.$route.params.all.papers == 4){
                       this.a = false
                       this.b = false
                       this.c = false
                       this.d = true
                       this.ruleForm.numberother = this.$route.params.all.number
                   }
                //    this.ruleForm.number = Number(this.$route.params.all.number)
                   this.ruleForm.phone = Number(this.$route.params.all.phone)
                    this.ruleForm.address = this.$route.params.all.papersAddress
                    this.ruleForm.address1 = this.$route.params.all.permanentAddress
                    this.ruleForm.cartype = this.$route.params.all.carType
                    this.ruleForm.data1 = this.$route.params.all.carModelOne
                    this.ruleForm.data2 = this.$route.params.all.carModelTwo
                    this.ruleForm.cartype1 = this.$route.params.all.carGenre?this.$route.params.all.carGenre.toString():''
                    this.ruleForm.amount = this.$route.params.all.displacement
                    this.ruleForm.number1 = this.$route.params.all.engineNumber
                    this.ruleForm.frame = this.$route.params.all.vin
                    this.ruleForm.number2 = this.$route.params.all.plateNumber
                    this.ruleForm.buytype = this.$route.params.all.buyCarType?this.$route.params.all.buyCarType.toString():''
                    if(this.$route.params.all.buyCarType == 2){
                        this.ruleForm.loan = ''
                        this.ruleForm.loannumber = ''

                    }else{
                        this.ruleForm.loan = this.$route.params.all.loanAmount
                    }
                    this.ruleForm.date1 = new Date(this.$route.params.all.buyCarDate)
                    this.dateinit = this.$route.params.all.buyCarDate
                    console.log(this.ruleForm.date1,this.$route.params.all.buyCarDate,new Date(this.$route.params.all.buyCarDate))
                    this.ruleForm.warranty = this.$route.params.all.guaranteeOne
                    this.ruleForm.warranty1 = this.$route.params.all.guaranteeTwo
                    this.ruleForm.money = this.$route.params.all.invoicePrice
                    
                    this.financeCompany = this.$route.params.all.financialCompany
                    this.ruleForm.person = this.$route.params.all.beneficiary
                    this.baoxianname = this.$route.params.all.productName
                    
                    // this.effectivedate = this.$route.params.all.effectiveDate
                    this.ruleForm.desc = this.$route.params.all.remark
                    this.moneysflag = false
                    this.moneys = this.$route.params.all.saleMoney
                    this.insuranceExtensionType = this.$route.params.all.insuranceExtensionType
                    this.yearsnum = this.$route.params.all.guaranteeOne
                    this.ruleForm.servicemoney = this.$route.params.all.serviceMoney
                    // 判断是否为延保类型产品
                    if(this.$route.params.all.insuranceExtensionType == 1){
                        this.flagsafe = true
                        this.ruleForm.warranty = this.$route.params.all.guaranteeOne
                        this.ruleForm.warranty1 = this.$route.params.all.guaranteeTwo
                        let c = this.$route.params.all.effectiveDate.split('-')
                        let a = this.$route.params.all.guaranteeOne
                        let b = Number(c[0])+Number(a)
                        console.log(c,a,b)
                        let r = this.$route.params.all.buyCarDate.split('-')
                        console.log(r)
                        console.log(Number(r[0]),Number(a),Number(c[0]))
                        console.log(Number(r[0]) + Number(a) == Number(c[0]))
                        if(Number(r[0]) + Number(a) == Number(c[0])){
                            this.effectivedate = this.$route.params.all.effectiveDate
                        }else{
                            this.effectivedate = b +'-'+c[1]+'-'+c[2]
                        }
                        // this.effectivedate = b +'-'+c[1]+'-'+c[2]
                        console.log(this.effectivedate)
                    }else{
                        this.flagsafe = false
                        //  let r = this.$route.params.all.buyCarDate.split('-')
                        // console.log(r)
                        this.effectivedate = this.$route.params.all.effectiveDate
                        // let timeStr = Number(r[0]) + Number(a)
                        // console.log(timeStr)
                        // this.effectivedate = timeStr + '-' + c[1] + '-' + c[2]
                    }
                    // 贷款合同号 
                    if(this.$route.params.all.buyCarType == 1){
                        this.flagbuycartype = true
                        this.ruleForm.loannumber = this.$route.params.all.loansNum
                    }else{
                        this.flagbuycartype = false
                    }
                    // 车辆所有人性质
                    if(this.$route.params.all.carNature == 2){
                        // this.ruleForm.resource = 
                        this.toggle = false
                    }
                    // 保险年限 
                    if(this.$route.params.all.insuranceYears){
                        this.yearArrs = this.$route.params.all.insuranceYears.split(',')
                    }
                    
                    console.log(this.yearArrs.indexOf(this.$route.params.all.insuranceAge.toString()))
                    if(this.yearArrs.indexOf(this.$route.params.all.insuranceAge.toString()) == -1){
                        this.ruleForm.years = ''
                    }else{
                        this.ruleForm.years = this.$route.params.all.insuranceAge?this.$route.params.all.insuranceAge.toString():''
                    }
                    // 身份证正面
                    this.fileList[0] = {url:this.$route.params.all.idCardFront}
                    if(this.fileList.length !== 0){
                        if(this.fileList[0].url !== ''){
                            this.hideUpload = true
                             this.dialogImageUrls = this.fileList[0].url
                             this.dialogImageUrl = this.fileList[0].url
                             window.localStorage.setItem('A',this.fileList[0].url)
                        }else{
                            this.fileList = []
                            this.hideUpload = false
                        }
                    }
                    // 身份证反面
                     this.fileList1[0] = {url:this.$route.params.all.idCardReverse}
                    if(this.fileList1.length !== 0){
                        if(this.fileList1[0].url !== ''){
                            this.hideUploadfan = true
                            this.dialogImageUrlfans = this.fileList1[0].url
                            this.dialogImageUrlfan = this.fileList1[0].url
                             window.localStorage.setItem('B',this.fileList1[0].url)
                        }else{
                            this.fileList1 = []
                            this.hideUploadfan = false
                        }
                    }
                    // 购车发票
                    this.fileList2[0] = {url:this.$route.params.all.invoice}
                    if(this.fileList2.length !== 0){
                        if(this.fileList2[0].url !== ''){
                            this.hideUploadinvoice = true
                            this.dialogImageUrlinvoices = this.fileList2[0].url
                             this.dialogImageUrlinvoice = this.fileList2[0].url
                              window.localStorage.setItem('C',this.fileList2[0].url)
                        }else{
                            this.fileList2 = []
                            this.hideUploadinvoice = false
                        }
                    }
                    // 贷款合同
                     this.fileList3[0] =  {url:this.$route.params.all.contract}
                     if(this.fileList3.length !== 0){
                        if(this.fileList3[0].url !== ''){
                            this.hideUploadloan = true
                            this.dialogImageUrlloans = this.fileList3[0].url
                            this.dialogImageUrlloan = this.fileList3[0].url
                            window.localStorage.setItem('D',this.fileList3[0].url)
                        }else{
                            this.fileList3 = []
                            this.hideUploadloan = false
                        }
                    }
                    // 行驶证
                     this.fileList4[0] =  {url:this.$route.params.all.drivingLicence}
                     if(this.fileList4.length !== 0){
                        if(this.fileList4[0].url !== ''){
                            this.hideUploadply = true
                            this.dialogImageUrlplys = this.fileList4[0].url
                            this.dialogImageUrlply = this.fileList4[0].url
                            window.localStorage.setItem('E',this.fileList4[0].url)
                        }else{
                            this.fileList4 = []
                            this.hideUploadply = false
                        }
                    }
                    // 合格证
                    this.fileList5[0] =  {url:this.$route.params.all.qualifiedCertificate}
                    if(this.fileList5.length !== 0){
                        if(this.fileList5[0].url !== ''){
                            this.hideUploadqualified = true
                            this.dialogImageUrlqualifieds = this.fileList5[0].url
                            this.dialogImageUrlqualified = this.fileList5[0].url
                            window.localStorage.setItem('F',this.fileList5[0].url)
                            
                        }else{
                            this.fileList5 = []
                            this.hideUploadqualified = false
                        }
                        
                    }
                    // 里程数
                    this.fileList6[0] =  {url:this.$route.params.all.mileage}
                    console.log(this.fileList6[0])
                    if(this.fileList6.length !== 0){
                        if(this.fileList6[0].url !== ''){
                            console.log(this.fileList6[0].url)
                             this.hideUploadmileage = true
                             this.dialogImageUrlmileages = this.fileList6[0].url
                             this.dialogImageUrlmileage = this.fileList6[0].url
                             window.localStorage.setItem('G',this.fileList6[0].url)
                        }else{
                            this.fileList6 = []
                            this.hideUploadmileage = false
                        }
                       
                    }
                    // 驾驶证
                    this.fileList8[0] =  {url:this.$route.params.all.driveLicence}
                    console.log( this.fileList8[0] !== '')
                    if(this.fileList8.length !== 0){
                        if(this.fileList8[0].url !== ''){
                             this.hideUploaddriveLicence = true
                             this.dialogImageUrldriveLicences = this.fileList8[0].url
                             this.dialogImageUrldriveLicence = this.fileList8[0].url
                             window.localStorage.setItem('I',this.fileList8[0].url)
                        }else{
                            this.fileList8 = []
                            this.hideUploaddriveLicence = false
                        }
                       
                    }
                    // 配置字段
                     this.extendFieldList = this.$route.params.all.extendFieldList
                     // 车辆必填信息(文本)
                    let a =  this.extendFieldList.map(item=>{
                        if(item.module == 1 && item.required == 1 && item.type == 1){
                            return item
                        }
                    })
                    console.log(a)
                    a.forEach(item=>{
                        console.log(item)
                        if(item !== undefined){
                            this.ruleForm.list1.push(item)
                        }
                    })
                    // 车辆必填信息(单选)
                    let e =  this.extendFieldList.map(item=>{
                        if(item.module == 1 && item.required == 1 && item.type == 2){
                            return item
                        }
                    })
                    console.log(e)
                    e.forEach(item=>{
                        console.log(item)
                        if(item !== undefined){
                            this.ruleForm.list4.push(item)
                        }
                    })
                    // 车辆模块非必填(文本)
                    let b =  this.extendFieldList.map(item=>{
                        if(item.module == 1 && item.required == 0 && item.type == 1){
                            return item
                        }
                    })
                    b.forEach(item=>{
                        if(item !== undefined){
                            this.ruleForm.list2.push(item)
                        }
                    })
                    // 车辆模块非必填(单选)
                    let f =  this.extendFieldList.map(item=>{
                        if(item.module == 1 && item.required == 0 && item.type == 2){
                            return item
                        }
                    })
                    f.forEach(item=>{
                        if(item !== undefined){
                            this.ruleForm.list5.push(item)
                        }
                    })
                    // 其他模块必填(文本)
                    let c =  this.extendFieldList.map(item=>{
                        if(item.module == 2 && item.required == 1 && item.type == 1){
                            return item
                        }
                    })
                    c.forEach(item=>{
                        if(item !== undefined){
                            this.ruleForm.list.push(item)
                        }
                    })
                    // 其他模块必填(单选)
                    let g =  this.extendFieldList.map(item=>{
                        if(item.module == 2 && item.required == 1 && item.type == 2){
                            return item
                        }
                    })
                    g.forEach(item=>{
                        if(item !== undefined){
                            this.ruleForm.list6.push(item)
                        }
                    })
                    // 其他模块非必填(文本)
                    let d =  this.extendFieldList.map(item=>{
                        if(item.module == 2 && item.required == 0 && item.type == 1){
                            return item
                        }
                    })
                    d.forEach(item=>{
                        if(item !== undefined){
                            this.ruleForm.list3.push(item)
                        }
                    })
                    // 其他模块非必填(单选)
                    let h =  this.extendFieldList.map(item=>{
                        if(item.module == 2 && item.required == 0 && item.type == 2){
                            return item
                        }
                    })
                    h.forEach(item=>{
                        if(item !== undefined){
                            this.ruleForm.list7.push(item)
                        }
                    })
                     //  其他的
                     this.$route.params.all.otherList.forEach(item=>{
                          this.fileList7.push({url:item})
                     })
                    console.log(this.fileList7)
                     if(this.fileList7.length !== 0){
                         if(this.fileList7[0].url ){
                          this.hideUploadother = true
                          this.dialogImageUrlothers = this.fileList7.map(item=>{
                              return item.url
                          })
                          this.dialogImageUrlother = this.fileList7.map(item=>{
                              console.log(item)
                              return item.url
                          })
                          window.localStorage.setItem('H',JSON.stringify(this.dialogImageUrlothers))
                        }else{
                            this.fileList7 = []
                            this.hideUploadother = false
                        }
                     }
                     if(this.fileList7.length >= 6){
                         this.hideUploadother = true
                     }else if(this.fileList7.length < 6){
                         this.hideUploadother = false
                     }
                    this.ruleForm.device  =  this.$route.params.all.deviceName
                    this.ruleForm.devicenum  =  this.$route.params.all.deviceCoding
                    this.ruleForm.datedevice  =  this.$route.params.all.installTime
                    this.codes = this.$route.params.all.code
                    this.statedraft = this.$route.params.all.state
                    this.draftid = this.$route.params.all.id
                    // 购车类型 金融公司 
                    if(this.$route.params.all.buyCarType == 1){
                        this.flagbuycartype = true
                          this.ruleForm.companyvalue = this.$route.params.all.financialCompany
                    }else{
                         this.flagbuycartype = false
                         this.ruleForm.companyvalue = ''
                    }
                    // 保险公司
                    // console.log(this.$route.params.all.productFinancialCompany.split(','))
                    // if(this.$route.params.all.productFinancialCompany.split(',').indexOf(this.$route.params.all.financialCompany) < 0){
                    //     this.ruleForm.companyvalue = ''
                    // }else{
                    //     this.ruleForm.companyvalue = this.$route.params.all.financialCompany
                    // }
                    
                    
                   
        }
        this.getdata()
        // this.getdevices()
    },
    destroyed(){
        window.localStorage.removeItem('A')
        window.localStorage.removeItem('B')
        window.localStorage.removeItem('C')
        window.localStorage.removeItem('D')
        window.localStorage.removeItem('E')
        window.localStorage.removeItem('F')
        window.localStorage.removeItem('G')
        window.localStorage.removeItem('H')
        window.localStorage.removeItem('I')
    },
    mounted(){
    },  
    methods:{
        async isCharges(){
            var {data:dt} = await isCharge({})
            console.log(dt)
            if(dt.code == 200){
                this.isChargemenu = dt.data.isCharge.split(',')
                console.log(this.isChargemenu)
            }
        },
        // async getdevices(){
        //     var {data:dt} = await getdevices({
        //         id:window.localStorage.getItem('shopId')
        //     })
        //     console.log(dt)
        //     if(dt.code == 200){
        //         if(dt.data.data.length !== 0){
        //             this.install = true
        //             this.state = 0
        //             this.deviceList = dt.data.data
        //             if(this.$route.params.all){
        //                 // 查询当前设备中有没有上次绑定的设备  
        //                 if(dt.data.data.length !== 0){
        //                     let devices = dt.data.data.map(item=>{
        //                         console.log(item)
        //                         return item.id
        //                     })
        //                     if(devices.indexOf(this.$route.params.all.deviceId) == -1){
        //                         this.ruleForm.device = ''
        //                         this.ruleForm.devicenum = ''
        //                     }
        //                 }
        //             }
        //         }else{
        //             this.install = false
        //             this.state = 2
        //             this.ruleForm.device  =  ''
        //             this.ruleForm.devicenum  =  ''
        //             this.ruleForm.datedevice  =  ''
        //         }
        //     }
        // },
        async failorder(){
            var {data:dt} = await queryShopProDev({
                saleId:this.$route.params.all.saleId
            })
            console.log(dt)
            if(dt.code == 200){
                if(dt.data.vo.list[0] !== null){
                    this.install = true
                    this.state = 0
                    this.deviceList = dt.data.vo.list
                    let devices = dt.data.vo.list.map(item=>{
                        console.log(item)
                        return item.id
                    })
                    if(devices.indexOf(dt.data.vo.deviceId) == -1){
                        this.ruleForm.device = ''
                        this.ruleForm.devicenum = ''
                    }else{
                        this.ruleForm.device = dt.data.vo.deviceName
                        this.ruleForm.devicenum = dt.data.vo.deviceCoding
                    }
                }
            }
        },
        async product(item){
            console.log(item)
            // this.templateId = item.templateId
            this.$refs["product"].scrollIntoView(true);
            console.log(this.oneflag)
             // 如果不是从草稿,创建新单过来的清空表单
            if(!this.$route.params.all && this.oneflag == 0){
                 this.ruleForm.cartype = '1'
                 this.ruleForm.resource = '1'
                 this.ruleForm.paperwork = '1'
                 this.ruleForm.name = ''
                 this.ruleForm.phone = ''
                 this.ruleForm.number = ''
                 this.ruleForm.numberpassport = ''
                 this.ruleForm.numbercredit = ''
                 this.ruleForm.numberother = ''
                 this.ruleForm.address = ''
                 this.ruleForm.address1 = ''
                 this.ruleForm.cartype1 = ''
                 this.ruleForm.date1 = ''
                 this.ruleForm.money = ''
                 this.ruleForm.number1 = ''
                 this.ruleForm.data1 = ''
                 this.ruleForm.data2 = ''
                 this.ruleForm.frame = ''
                 this.ruleForm.loan = ''
                 this.ruleForm.buytype = '2'
                 this.ruleForm.warranty = ''
                 this.ruleForm.warranty1 = ''
                 this.ruleForm.person = ''
                 this.ruleForm.years = ''
                 this.ruleForm.desc = ''
                 this.ruleForm.loannumber = ''
                 this.ruleForm.amount = ''
                 this.hideUpload = false
                 this.hideUploadfan = false,
                 this.hideUploadinvoice = false
                 this.hideUploadloan = false
                 this.hideUploadply = false
                 this.hideUploadqualified = false
                 this.hideUploadmileage = false
                 this.hideUploadother = false
                 this.moneysflag = false
                 
            }
            // 判断是不是研报类型的产品
            if(item.insuranceExtensionType == 1){
                this.flagsafe = true
            }else{
                this.flagsafe = false
                this.ruleForm.warranty = ''
                this.ruleForm.warranty1 = ''
                console.log(this.ruleForm.date1)
                if(this.ruleForm.date1 !== ''){
                    var curDates = new Date(this.ruleForm.date1);
                    var nextDates = new Date(curDates.getTime() + 24*60*60*1000); //后一天
                    console.log(nextDates)
                    var dates = new Date(nextDates)
                    var ys = dates.getFullYear()
                    var ms = dates.getMonth() + 1
                    ms = ms < 10 ? ('0' + ms) : ms
                    var ds = dates.getDate()
                    ds = ds < 10 ? ('0' + ds) : ds
                    this.effectivedate = ys+'-'+ms+'-'+ds
                    console.log(this.effectivedate)
                }
            }
            this.one = false
            this.two = true
            this.three = false
            this.four = false
            this.baoxianname = item.name
            this.productId = item.id
            this.yearArrs = item.insuranceYears.split(',')
            this.ruleForm.list = []
            this.ruleForm.list1 = []
            this.ruleForm.list2 = []
            this.ruleForm.list3 = []
            this.ruleForm.list4 = []
            this.ruleForm.list5 = []
            this.ruleForm.list6 = []
            this.ruleForm.list7 = []
            var {data:dt} = await customizeinfo({
                productId:item.id
            })
            console.log(dt)
            if(dt.code == 200){
                this.Lists = dt.data.finalList
                // 车辆必填信息(文本)
                let a =  dt.data.finalList.map(item=>{
                    if(item.module == 1 && item.required == 1 && item.type == 1){
                        return item
                    }
                })
                console.log(a)
                a.forEach(item=>{
                    console.log(item)
                    if(item !== undefined){
                        this.list1.push(item)
                        this.ruleForm.list1.push(item)
                    }
                })
                console.log(this.ruleForm.list1)
                // 车辆必填信息(单选)
                let e =  dt.data.finalList.map(item=>{
                    if(item.module == 1 && item.required == 1 && item.type == 2){
                        return item
                    }
                })
                console.log(e)
                e.forEach(item=>{
                    console.log(item)
                    if(item !== undefined){
                        this.ruleForm.list4.push(item)
                    }
                })
                // 车辆模块非必填(文本)
                let b =  dt.data.finalList.map(item=>{
                    if(item.module == 1 && item.required == 0 && item.type == 1){
                        return item
                    }
                })
                b.forEach(item=>{
                    if(item !== undefined){
                        this.ruleForm.list2.push(item)
                    }
                })
                // 车辆模块非必填(单选)
                let f =  dt.data.finalList.map(item=>{
                    if(item.module == 1 && item.required == 0 && item.type == 2){
                        return item
                    }
                })
                f.forEach(item=>{
                    if(item !== undefined){
                        this.ruleForm.list5.push(item)
                    }
                })
                // 其他模块必填(文本)
                let c =  dt.data.finalList.map(item=>{
                    if(item.module == 2 && item.required == 1 && item.type == 1){
                        return item
                    }
                })
                c.forEach(item=>{
                    if(item !== undefined){
                        this.ruleForm.list.push(item)
                    }
                })
                // 其他模块必填(单选)
                let g =  dt.data.finalList.map(item=>{
                    if(item.module == 2 && item.required == 1 && item.type == 2){
                        return item
                    }
                })
                g.forEach(item=>{
                    if(item !== undefined){
                        this.ruleForm.list6.push(item)
                    }
                })
                // 其他模块非必填(文本)
                 let d =  dt.data.finalList.map(item=>{
                    if(item.module == 2 && item.required == 0 && item.type == 1){
                        return item
                    }
                })
                d.forEach(item=>{
                    if(item !== undefined){
                        this.ruleForm.list3.push(item)
                    }
                })
                // 其他模块非必填(单选)
                 let h =  dt.data.finalList.map(item=>{
                    if(item.module == 2 && item.required == 0 && item.type == 2){
                        return item
                    }
                })
                h.forEach(item=>{
                    if(item !== undefined){
                        this.ruleForm.list7.push(item)
                    }
                })
            }
            this.insuranceExtensionType = item.insuranceExtensionType  
            if(this.$route.params.all){
                // 从草稿箱，创建新单过来   判断如果是延保生效日期不变   如果不是延保 就是购车日期的后一天
                 if(this.$route.params.all.insuranceExtensionType == item.insuranceExtensionType){
                       let r = this.$route.params.all.buyCarDate.split('-')
                       console.log(r)
                       let a = this.$route.params.all.guaranteeOne
                       console.log(a)
                       let timeStr =Number(r[0])+Number(a)
                       let dayStr = Number(r[2]) + Number(1)
                        console.log(timeStr)
                     this.effectivedate = timeStr + '-' + r[1] +'-' + dayStr
                 }else{
                     console.log(new Date(this.$route.params.all.buyCarDate))
                     var curDate = new Date(this.$route.params.all.buyCarDate)
                     var nextDate = new Date(curDate.getTime() + 24*60*60*1000); //后一天
                     console.log(nextDate)
                     var date = new Date(nextDate)
                     var m = date.getMonth() + 1
                     m = m < 10 ? ('0' + m) : m
                     var d = date.getDate()
                     d = d < 10 ? ('0' + d) : d
                     var y = date.getFullYear()
                     const time = y + '-' + m + '-' + d
                     this.effectivedate = time

                 }
            }
            let arrS = item.insuranceYears.split(',')
            if(this.$route.params.all){
                if(arrS.indexOf(this.$route.params.all.insuranceAge.toString()) == -1){
                    this.ruleForm.years = ''
                }   
            }
            // 如果有选择的保险年限就判断当前年限组里边包含选择的年限吗  如果不包含就清空
            console.log(this.ruleForm.years)
            if(this.ruleForm.years !== ''){
                // 不存在返回-1   存在返回索引
                if(item.insuranceYears.split(',').indexOf(this.ruleForm.years) < 0){
                    this.ruleForm.years = ''
                }
            }
              this.companyoptions = item.financeCompany.split(',') 
            // 金融公司
            if(this.$route.params.all){
                if(item.financeCompany.split(',').indexOf(this.$route.params.all.financialCompany) < 0){
                    this.ruleForm.companyvalue = ''
                }else{
                    this.ruleForm.companyvalue = this.$route.params.all.financialCompany
                }
            }         
            if(!this.$route.params.all){
                 this.ruleForm.years = ''
            }
            // pdf模板
            // console.log(item.templateId.split(',').indexOf('2') !== -1)
            if(item.templateId){
                let charge = item.isCharge.split(',')
                let template = item.templateId.split(',')
                console.log(charge,template)
                let aindex = charge.map(items=>{
                       return template.indexOf(items)
                })
                console.log(aindex)
                let bindex = aindex.map(item=>{
                    console.log(item)
                    if(item !== -1){
                        return item
                    }
                })
                console.log(bindex)
                let cindex = []
                bindex.forEach(item=>{
                    if(item !== undefined){
                        cindex.push(item)
                    }
                })
                console.log(cindex)
                if(cindex.length > 0){
                     this.templateflag = true
                }else{
                    this.templateflag = false
                }
            }
            // console.log(item.templateId.split(',').indexOf('2') !== -1)
            // if(item.templateId){
            //     if(item.templateId.split(',').indexOf('2') !== -1 || item.templateId.split(',').indexOf('6') !== -1 || item.templateId.split(',').indexOf('10') !== -1|| item.templateId.split(',').indexOf('11') !== -1|| item.templateId.split(',').indexOf('12') !== -1|| item.templateId.split(',').indexOf('14') !== -1){
            //         this.templateflag = true
            //     }else{
            //         this.templateflag = false
            //     }
            // }
            // 不等于0就表示是有安装信息的
            if(item.deviceName.length !== 0){
                this.install = true
                this.state = 0
                this.deviceList = item.deviceName
                if(this.$route.params.all){
                    // 查询当前设备中有没有上次绑定的设备  
                    let devices = item.deviceName.map(item=>{
                        return item.id
                    })
                    if(devices.indexOf(this.$route.params.all.deviceId) == -1){
                        this.ruleForm.device = ''
                        this.ruleForm.devicenum = ''
                    }
                }
            }else{
                this.install = false
                this.state = 2
                this.ruleForm.device  =  ''
                this.ruleForm.devicenum  =  ''
                this.ruleForm.datedevice  =  ''
            }
        },
        submitForm() {
                        console.log(this.buycarddp,this.loanht,this.paperwork,this.hegezheng,this.lichengshu,this.xingshizheng,this.qita)
            if(this.buycarddp == 1 || this.loanht == 1 || this.paperwork == 1 || this.hegezheng == 1 || this.lichengshu == 1 || this.xingshizheng == 1 || this.qita == 1){
                return this.$message.warning('当前有未上传完成的图片，请稍等')
            }

            this.Lists = this.ruleForm.list.concat(this.ruleForm.list1).concat(this.ruleForm.list2).concat(this.ruleForm.list3).concat(this.ruleForm.list4).concat(this.ruleForm.list5).concat(this.ruleForm.list6).concat(this.ruleForm.list7)           
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) { 
                    
                    var {data:dt1} = await trialPremium({
                        id:this.$route.params.safefails?this.$route.params.all.productId:this.productId,
                        shopId:Number(window.localStorage.getItem('shopId')),
                        loanAmount:this.ruleForm.loan,
                        insuranceAge:this.ruleForm.years,
                        invoicePrice:this.ruleForm.money
                    })
                    console.log(dt1)
                    this.premium = dt1.data.money
                        if(dt1.code == 200){
                            if(this.Lists){
                                    this.extendFieldList = this.Lists.map(item=>{
                                        let obj = {}
                                        obj.formName = item.title
                                        obj.formValue = item.datas? item.datas?item.datas:'' : item.radios ? item.radios : '' ,
                                        obj.module = item.module
                                        return obj
                                    })
                            }
                            var {data:dt} = await saveDrafts({
                                carNature:this.ruleForm.resource,
                                papers:this.ruleForm.paperwork,
                                name:this.ruleForm.name,
                                number: this.ruleForm.paperwork == 1? this.ruleForm.number : this.ruleForm.paperwork == 2? this.ruleForm.numberpassport :  this.ruleForm.paperwork == 3?this.ruleForm.numbercredit:this.ruleForm.numberother ,
                                phone:this.ruleForm.phone,
                                papersAddress:this.ruleForm.address,
                                // permanentAddress:this.ruleForm.address1,
                                carType:this.ruleForm.cartype,
                                carModelOne:this.ruleForm.data1,
                                carModelTwo:this.ruleForm.data2,
                                carGenre:this.ruleForm.cartype1,
                                displacement:this.ruleForm.amount,
                                engineNumber:this.ruleForm.number1,
                                vin:this.ruleForm.frame,
                                // plateNumber:this.ruleForm.number2,
                                buyCarType:this.ruleForm.buytype,
                                buyCarDate:this.dateinit,
                                guaranteeOne:this.ruleForm.warranty,
                                guaranteeTwo:this.ruleForm.warranty1,
                                invoicePrice:this.ruleForm.money,
                                loanAmount:this.ruleForm.loan,
                                financialCompany:this.ruleForm.companyvalue,
                                beneficiary:this.ruleForm.person,
                                productId:this.$route.params.safefails?this.$route.params.all.productId:this.productId,
                                productName:this.baoxianname,
                                insuranceAge:this.ruleForm.years,
                                effectiveDate:this.effectivedate,
                                remark:this.ruleForm.desc,
                                // 身份证正面
                                idCardFront:this.dialogImageUrls,
                                // 身份证反面
                                idCardReverse:this.dialogImageUrlfans,
                                // 购车发票
                                invoice:this.dialogImageUrlinvoices,
                                // 贷款合同
                                contract:this.dialogImageUrlloans,
                                // 行驶证
                                drivingLicence:this.dialogImageUrlplys,
                                // 合格证
                            qualifiedCertificate:this.dialogImageUrlqualifieds,
                                // 里程数
                                mileage:this.dialogImageUrlmileages,
                                // 驾驶证
                                driveLicence:this.dialogImageUrldriveLicences,
                                extendFieldList:this.extendFieldList?this.extendFieldList:[],
                                state:this.draftstate2?1:this.state,
                                otherList:this.dialogImageUrlothers,
                                code:this.$route.params.all?this.$route.params.flagnews?'':this.codes:'',
                                statedraft:this.$route.params.all?this.$route.params.flagnews?'':this.statedraft:'',
                                draftid:this.$route.params.all?this.$route.params.flagnews?'':this.draftid:'',
                                shopId:window.localStorage.getItem('shopId'),
                                saleMoney:dt1.data.money.toString(),
                                loansNum:this.ruleForm.loannumber,
                                // marketingMoney:dt1.data.marketingMoney.toString(),
                                serviceMoney:this.ruleForm.servicemoney,
                                // templateId:this.templateId
                                // true 有设备 false 没有设备
                                install:this.install?1:2,
                                // true 从草稿进来的  false 是正常进入
                                draft:this.draft?1:2

                            })
                                console.log(dt)
                                if(!this.install){
                                    window.localStorage.removeItem('A')
                                    window.localStorage.removeItem('B')
                                    window.localStorage.removeItem('C')
                                    window.localStorage.removeItem('D')
                                    window.localStorage.removeItem('E')
                                    window.localStorage.removeItem('F')
                                    window.localStorage.removeItem('G')
                                    window.localStorage.removeItem('H') 
                                }   
                                if(dt.code == 200){
                                        if(this.install){
                                            
                                            this.orderid = dt.data.id
                                            this.codestr = dt.data.code
                                            if(this.draftstate2){
                                                this.$message.success('保存草稿成功')
                                                this.one = true
                                                this.two = false
                                                this.three = false
                                                this.four = false
                                                this.draftstate = false
                                                this.draftstate2 = false
                                                
                                            }else{
                                                this.one = false
                                                this.two = false
                                                this.three = true
                                                this.four = false
                                                console.log(this.ruleForm)
                                            }
                                        }else{
                                            this.one = false
                                            this.two = false
                                            this.three = false
                                            this.four = true
                                        }
                            }
                        }else{
                            this.$message.error(dt1.message)
                        }
                            
                    }else{
                        let List1 = []
                        let List2 = []
                         List1 =  this.ruleForm.list1.concat(this.ruleForm.list)
                         List2 =  this.ruleForm.list4.concat(this.ruleForm.list6)
                         console.log(List1,List2)
                        if(this.insuranceExtensionType == 1){
                            if(this.ruleForm.name == ''){
                                this.$message.error('请填写名称')
                                return
                            }
                            if(this.ruleForm.phone == ''){
                                this.$message.error('请填写联系电话')
                                return
                            }
                            if(this.ruleForm.address == ''){
                                this.$message.error('请填写证件详细地址')
                                return
                            }
                            if(this.ruleForm.cartype1 == ''){
                                this.$message.error('请选择证车辆类型')
                                return
                            }
                            if(this.ruleForm.number1 == ''){
                                this.$message.error('请填写发动机号')
                                return
                            }
                            if(this.ruleForm.data1 == ''){
                                this.$message.error('请填写车辆品牌')
                                return
                            }
                            if(this.ruleForm.data2 == ''){
                                this.$message.error('请填写车辆型号')
                                return
                            }
                            if(this.ruleForm.frame == ''){
                                this.$message.error('请填写车架号')
                                return
                            }
                            if(this.ruleForm.date1 == ''){
                                this.$message.error('请填写初始购车日期')
                                return
                            }
                            if(this.ruleForm.buytype == ''){
                                this.$message.error('请选择购车类型')
                                return
                            }
                            if(this.flagbuycartype){
                                if(this.ruleForm.loan == ''){
                                    this.$message.error('请填写贷款金额')
                                    return
                                }else if(this.ruleForm.loannumber == ''){
                                     this.$message.error('请填写贷款合同号')
                                     return
                                }else if(this.ruleForm.companyvalue == ''){
                                    this.$message.error('请选择金融公司')
                                    return
                                }
                                
                            }
                            if(this.ruleForm.money == ''){
                                this.$message.error('请填写购车发票价格')
                                return
                            }
                            if(this.ruleForm.warranty == ''){
                                    this.$message.error('请填写质保年限')
                                    return
                            }
                            if(this.ruleForm.warranty1 == ''){
                                this.$message.error('请填写质保公里')
                                return
                            }
                            if(this.ruleForm.years == '' || this.ruleForm.years == undefined){
                                this.$message.error('请选择保险年限')
                                return
                            }
                            if(this.dialogImageUrl == '' || this.dialogImageUrl == undefined){
                                this.$message.error('请上传身份证正面照片')
                                return
                            }
                            if(this.dialogImageUrlfan == '' || this.dialogImageUrlfan == undefined ){
                                this.$message.error('请上传身份证反面照片')
                                return
                            }
                            if(this.ruleForm.paperwork == 1 || this.ruleForm.paperwork == '1'){
                                if(this.ruleForm.number == ''){
                                    this.$message.error('请填写身份证号码')
                                     return
                                }
                               
                            }else if(this.ruleForm.paperwork == 2){
                                if(this.ruleForm.numberpassport == ''){
                                    this.$message.error('请填写护照号码')
                                     return
                                }
                               
                            }else if(this.ruleForm.paperwork == 3){
                                if(this.ruleForm.numbercredit == ''){
                                    this.$message.error('请填写统一社会信用代码证号码')
                                     return
                                }
                               
                            }else if(this.ruleForm.paperwork == 4){
                                if(this.ruleForm.numberother == ''){
                                    this.$message.error('请填写其他证件号码')
                                    return
                                }
                                
                            }

                            if(List1.length>0){
                                for(var i=0;i<List1.length;i++){
                                    console.log(List1)
                                    console.log(List1[i].datas)
                                    if(List1[i].datas == ''|| List1[i].datas == undefined){
                                        this.$message.error(`${List1[i].title}必填`)
                                        return
                                    }
                                }
                            }
                            if(List2.length>0){
                                for(var j=0;j<List2.length;j++){
                                    console.log(List2[j].radios)
                                    if(List2[j].radios == ''|| List2[j].radios == undefined){
                                        this.$message.error(`${List2[j].title}必选`)
                                        return
                                    }
                                }
                            }
       
                        }else{
                            if(this.ruleForm.name == ''){
                                this.$message.error('请填写名称')
                                return
                            }
                            if(this.ruleForm.phone == ''){
                                this.$message.error('请填写联系电话')
                                return
                            }
                            if(this.ruleForm.address == ''){
                                this.$message.error('请填写证件详细地址')
                                return
                            }
                            if(this.ruleForm.cartype1 == ''){
                                this.$message.error('请选择证车辆类型')
                                return
                            }
                            if(this.ruleForm.number1 == ''){
                                this.$message.error('请填写发动机号')
                                return
                            }
                            if(this.ruleForm.data1 == ''){
                                this.$message.error('请填写车辆品牌')
                                return
                            }
                            if(this.ruleForm.data2 == ''){
                                this.$message.error('请填写车辆型号')
                                return
                            }
                            if(this.ruleForm.frame == ''){
                                this.$message.error('请填写车架号')
                                return
                            }
                            if(this.ruleForm.date1 == ''){
                                this.$message.error('请填写初始购车日期')
                                return
                            }
                            if(this.ruleForm.buytype == ''){
                                this.$message.error('请选择购车类型')
                                return
                            }
                            if(this.flagbuycartype){
                                if(this.ruleForm.loan == ''){
                                    this.$message.error('请填写贷款金额')
                                     return
                                }else if(this.ruleForm.loannumber == ''){
                                     this.$message.error('请填写贷款合同号')
                                      return
                                }else if(this.ruleForm.companyvalue == ''){
                                    this.$message.error('请选择金融公司')
                                     return
                                }
                               
                            }
                            if(this.ruleForm.money == ''){
                                this.$message.error('请填写购车发票价格')
                                return
                            }
                            if(this.ruleForm.years == '' || this.ruleForm.years == undefined){
                                this.$message.error('请选择保险年限')
                                return
                            }
                            if(this.dialogImageUrl == '' || this.dialogImageUrl == undefined){
                                this.$message.error('请上传身份证正面照片')
                                return
                            }
                            if(this.dialogImageUrlfan == '' || this.dialogImageUrlfan == undefined ){
                                this.$message.error('请上传身份证反面照片')
                                return
                            }

                            if(this.ruleForm.paperwork == 1 || this.ruleForm.paperwork == '1'){
                                if(this.ruleForm.number == ''){
                                    this.$message.error('请填写身份证号码')
                                     return
                                }
                               
                            }else if(this.ruleForm.paperwork == 2){
                                if(this.ruleForm.numberpassport == ''){
                                    this.$message.error('请填写护照号码')
                                     return
                                }
                               
                            }else if(this.ruleForm.paperwork == 3){
                                if(this.ruleForm.numbercredit == ''){
                                    this.$message.error('请填写统一社会信用代码证号码')
                                     return
                                }
                               
                            }else if(this.ruleForm.paperwork == 4){
                                if(this.ruleForm.numberother == ''){
                                    this.$message.error('请填写其他证件号码')
                                    return
                                }
                                
                            }

                            if(List1.length>0){
                                for(var k=0;k<List1.length;k++){
                                    console.log(List1)
                                    console.log(List1[k].datas)
                                    if(List1[k].datas == ''|| List1[k].datas == undefined){
                                        this.$message.error(`${List1[k].title}必填`)
                                        return
                                    }
                                }
                            }
                            if(List2.length>0){
                                for(var m=0;m<=List2.length;m++){
                                    console.log(List2[m].radios)
                                    if(List2[m].radios == ''|| List2[m].radios == undefined){
                                        this.$message.error(`${List2[m].title}必选`)
                                        return
                                    } 
                                }
                            }
                        }
                        
                    }   
            });
        },
        submitForm2(){
              this.$refs.ruleForm.validate(async (valid) => {
                    if (valid) {
                        var {data:dt1} = await verifyFacility({
                            shopId:window.localStorage.getItem('shopId'),
                            deviceCoding:this.devicevalue?this.devicevalue :this.$route.params.all.deviceCoding,
                            deviceId:this.deviceid?this.deviceid:this.$route.params.all.deviceId,
                             draft:this.draft?1:2,
                            
                        })
                        console.log(dt1)
                        if(dt1.code == 200){
                            var {data:dt} = await saveFacility({
                                id:this.orderid,
                                deviceName:this.ruleForm.device,
                                deviceCoding:this.ruleForm.devicenum,
                                installTime:this.ruleForm.datedevice,
                                shopId:window.localStorage.getItem('shopId'),
                                productId:this.productId,
                                state:this.draftstate?1:2,
                                code:this.$route.params.all?this.$route.params.flagnews?this.codestr:this.codes:this.codestr,
                                statedraft:this.$route.params.all?this.$route.params.flagnews?'':this.statedraft:'',
                                 draftid:this.$route.params.all?this.$route.params.flagnews?'':this.draftid:'',
                                 saleMoney:this.premium,
                                  failfinsh:this.failfinsh?1:2

                            })
                            console.log(dt)
                            window.localStorage.removeItem('A')
                            window.localStorage.removeItem('B')
                            window.localStorage.removeItem('C')
                            window.localStorage.removeItem('D')
                            window.localStorage.removeItem('E')
                            window.localStorage.removeItem('F')
                            window.localStorage.removeItem('G')
                            window.localStorage.removeItem('H')
                            if(dt.code == 200){
                                if(this.draftstate){
                                     this.$message.success('保存草稿成功')
                                    this.one = true
                                    this.two = false
                                    this.three = false
                                    this.four = false  
                                    this.draftstate = false
                                    this.draftstate2 = false
                                }else{
                                    this.one = false
                                    this.two = false
                                    this.three = false
                                    this.four = true
                                }
                                
                            }else{
                                this.$message.error(dt.message)
                            }
                        }else{
                            this.$message.error(dt1.message)
                        } 
                    }else{
                        if(this.ruleForm.device == ''){
                            this.$message.error('请选择设备')
                        }else if(this.ruleForm.devicenum == ''){
                            this.$message.error('请填写设备编码')
                        }
                    }
              })
        },
        // 身份证正面
        async handleRemove(file, fileList) {
            console.log(file, fileList);
            this.hideUpload = fileList.length >= this.limitCount;
            this.dialogImageUrl = '' 
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url,
            //    idCardFront:'idCardFront'
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrls = ''
                 window.localStorage.removeItem('A')
            // }
            
        },
        handlePictureCardPreview(file) {
            console.log(file)
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        changeImg(file,fileList){
            console.log(file, fileList,11111);
            if(fileList[0].response){
                this.hideUpload = fileList.length >= this.limitCount;
                this.dialogImageUrl = file.url
            }else{
                this.dialogImageUrl = ''
                this.hideUpload = true
            }
            
        },
        imgsuccess(file,fileList,response){
            console.log(file,fileList,response,123456)
            this.dialogImageUrls = file.data.url
            window.localStorage.setItem('A',file.data.url)
        },
        // 身份证反面
        async handleRemovefan(file, fileList) {
            console.log(file, fileList);
            this.hideUploadfan = fileList.length >= this.limitCountfan;
            this.dialogImageUrlfan = ''
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrlfans = ''
                 window.localStorage.removeItem('B')
            // }
        },
        handlePictureCardPreviewfan(file) {
            this.dialogImageUrlfan = file.url;
            this.dialogVisiblefan = true;
        },
        changeImgfan(file,fileList){
            console.log(file, fileList);
            if(fileList[0].response){
                this.hideUploadfan = fileList.length >= this.limitCountfan;
                this.dialogImageUrlfan = file.url
            }else{
                this.dialogImageUrlfan = ''
                this.hideUploadfan = true
            }
            
        },
        imgsuccessfan(file,fileList,response){
            console.log(file,fileList,response,123456)
                this.dialogImageUrlfans = file.data.url
                window.localStorage.setItem('B',file.data.url) 
        },
        // 购车发票
        async handleRemoveinvoice(file, fileList) {
            console.log(file, fileList);
            this.buycarddp = 0
            this.hideUploadinvoice = fileList.length >= this.limitCountinvoice;
            this.dialogImageUrlinvoice = ''
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrlinvoices = ''
                window.localStorage.removeItem('C')
            // }
        },
        handlePictureCardPreviewinvoice(file) {
            this.dialogImageUrlinvoice = file.url;
            this.dialogVisibleinvoice = true;
        },
        changeImginvoice(file,fileList){
            console.log(file, fileList);
            if(fileList[0].response){
                this.buycarddp = 0
                this.hideUploadinvoice = fileList.length >= this.limitCountinvoice;
                this.dialogImageUrlinvoice = file.url
            }else{
                this.buycarddp = 1
                this.dialogImageUrlinvoice = ''
                this.hideUploadinvoice = true
            }
            
        },
        imgsuccessinvoice(file,fileList,response){
            console.log(file,fileList,response,123456)
            this.buycarddp = 0
            this.dialogImageUrlinvoices = file.data.url
            window.localStorage.setItem('C',file.data.url)
        },
        // 贷款合同
        async handleRemoveloan(file, fileList) {
            console.log(file, fileList);
            this.loanht = 0
            this.hideUploadloan = fileList.length >= this.limitCountloan;
            this.dialogImageUrlloan = ''
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrlloans = ''
               window.localStorage.removeItem('D')
            // }
        },
        handlePictureCardPreviewloan(file) {
            this.dialogImageUrlloan = file.url;
            this.dialogVisibleloan = true;
        },
        changeImgloan(file,fileList){
            console.log(file, fileList);
            if(fileList[0].response){
                this.loanht = 0
                this.hideUploadloan = fileList.length >= this.limitCountloan;
                this.dialogImageUrlloan = file.url
            }else{
                this.loanht = 1
                this.dialogImageUrlloan = ''
                this.hideUploadloan = true
            }
            
        },
        imgsuccessloan(file,fileList,response){
            console.log(file,fileList,response,123456)
            this.loanht = 0
            this.dialogImageUrlloans = file.data.url
            window.localStorage.setItem('D',file.data.url)
        },
        // 行驶证
        async handleRemoveply(file, fileList) {
            console.log(file, fileList);
            this.paperwork = 0
            this.hideUploadply = fileList.length >= this.limitCountply;
            this.dialogImageUrlply = ''
            // var {data:dt} = await remove({
            //   url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrlplys = ''
               window.localStorage.removeItem('E')
            // }
        },
        handlePictureCardPreviewply(file) {
            this.dialogImageUrlply = file.url;
            this.dialogVisibleply = true;
        },
        changeImgply(file,fileList){
            console.log(file, fileList);
            if(fileList[0].response){
                this.paperwork = 0
                this.hideUploadply = fileList.length >= this.limitCountply;
                this.dialogImageUrlply = file.url
            }else{
                this.paperwork = 1
                this.dialogImageUrlply = ''
                this.hideUploadply = true
            }
            
        },
        imgsuccessply(file,fileList,response){
            console.log(file,fileList,response,123456)
            this.paperwork = 0
            this.dialogImageUrlplys = file.data.url
            window.localStorage.setItem('E',file.data.url)
        },
        // 合格证 qualified
        async handleRemovequalified(file, fileList) {
            console.log(file, fileList);
            this.hegezheng = 0
            this.hideUploadqualified = fileList.length >= this.limitCountqualified;
            this.dialogImageUrlqualified = ''
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrlqualifieds = ''
                window.localStorage.removeItem('F')
            // }
        },
        handlePictureCardPreviewqualified(file) {
            this.dialogImageUrlqualified = file.url;
            this.dialogVisiblequalified = true;
        },
        changeImgqualified(file,fileList){
            console.log(file, fileList);
            if(fileList[0].response){
                this.hegezheng = 0
                this.hideUploadqualified = fileList.length >= this.limitCountqualified;
                this.dialogImageUrlqualified = file.url
            }else{
                this.hegezheng = 1
                this.dialogImageUrlqualified = ''
                this.hideUploadqualified = true
            }
            
        },
        imgsuccessqualified(file,fileList,response){
            console.log(file,fileList,response,123456)
            this.hegezheng = 0
            this.dialogImageUrlqualifieds = file.data.url
            window.localStorage.setItem('F',file.data.url)
        },
        // 里程数 mileage
        async handleRemovemileage(file, fileList) {
            console.log(file, fileList);
            this.lichengshu = 0
            this.hideUploadmileage = fileList.length >= this.limitCountmileage;
            this.dialogImageUrlmileage = ''
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrlmileages = ''
                window.localStorage.removeItem('G')
            // }
        },
        handlePictureCardPreviewmileage(file) {
            this.dialogImageUrlmileage = file.url;
            this.dialogVisiblemileage = true;
        },
        changeImgmileage(file,fileList){
            console.log(file, fileList);
            if(fileList[0].response){
                this.lichengshu = 0
                this.hideUploadmileage = fileList.length >= this.limitCountmileage;
                this.dialogImageUrlmileage = file.url
            }else{
                 this.lichengshu = 1
                this.dialogImageUrlmileage = ''
                this.hideUploadmileage = true
            }
            
        },
        imgsuccessmileage(file,fileList,response){
            console.log(file,fileList,response,123456)
             this.lichengshu = 0
            this.dialogImageUrlmileages = file.data.url
            window.localStorage.setItem('G',file.data.url)
        },
        // 驾驶证 mileage
         // 驾驶证
            // hideUploaddriveLicence:false,
            // dialogImageUrldriveLicence:'',
            // dialogVisibledriveLicence:false,
            // limitCountdriveLicence:1,
        async handleRemovedriveLicence(file, fileList) {
            console.log(file, fileList);
            this.jiashizheng = 0
            this.hideUploaddriveLicence = fileList.length >= this.limitCountdriveLicence;
            this.dialogImageUrldriveLicence = ''
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                this.dialogImageUrldriveLicences = ''
                window.localStorage.removeItem('I')
            // }
        },
        handlePictureCardPreviewdriveLicence(file) {
            this.dialogImageUrldriveLicence = file.url;
            this.dialogVisibledriveLicence = true;
        },
        changeImgdriveLicence(file,fileList){
            console.log(file, fileList);
            if(fileList[0].response){
                this.jiashizheng = 0
                this.hideUploaddriveLicence = fileList.length >= this.limitCountdriveLicence;
                this.dialogImageUrldriveLicence = file.url
            }else{
                this.jiashizheng = 1
                this.dialogImageUrldriveLicence = ''
                this.hideUploaddriveLicence = true
            }
            
        },
        imgsuccessdriveLicence(file,fileList,response){
            console.log(file,fileList,response,123456)
            this.jiashizheng = 0
            this.dialogImageUrldriveLicences = file.data.url
            window.localStorage.setItem('I',file.data.url)
        },
        // 其他other
        async handleRemoveother(file, fileList) {
            console.log(file, fileList);
            fileList.forEach(item=>{
                if(item.response && item.url.indexOf('blob') !== -1){
                    this.qita = 0
                }else if(item.url.indexOf('http') !== -1 && item.url.indexOf('blob') == -1){
                    this.qita = 0
                }else{
                    this.qita = 1
                }
            }) 
            if(fileList.length == 0){
                    this.qita = 0
            }
            this.hideUploadother = fileList.length >= this.limitCountother;
            this.dialogImageUrlother = ''
            // var {data:dt} = await remove({
            //    url:file.response?file.response.data.url:file.url
            // })
            // console.log(dt,111)
            // if(dt.code == 200){
                let arr = JSON.parse( window.localStorage.getItem('H'))?JSON.parse( window.localStorage.getItem('H')):this.$route.params.all.otherList
                console.log(arr)
                let a = file.response?file.response.data.url:file.url
                console.log(a)
                if(arr.indexOf(a) !== -1){
                    console.log(arr.indexOf(a))
                    arr.splice(arr.indexOf(a),1)
                // }
                console.log(arr)
                this.dialogImageUrlothers = arr
                window.localStorage.setItem('H',JSON.stringify(arr))
            }
        },
        handlePictureCardPreviewother(file) {
            this.dialogImageUrlother = file.url;
            this.dialogVisibleother = true;
        },
        changeImgother(file,fileList){
            console.log(file, fileList);
            this.hideUploadother = fileList.length >= this.limitCountother;
            this.dialogImageUrlother = file.url
            fileList.forEach(item=>{
                console.log(item)
                if(item.response){
                    this.qita = 0
                }else{
                    this.qita = 1
                }
                console.log(this.qita)
            })
        },
        imgsuccessother(file,fileList,response){
            console.log(file,fileList,response,123456)
            this.dialogImageUrlothers = response.map(item=>{
                if(item.response){
                    this.qita = 0
                    return item.response.data.url
                }else{
                    this.qita = 1
                    return item.url
                }  
            })
        console.log(this.qita)
            console.log(this.dialogImageUrlothers)
            window.localStorage.setItem('H',JSON.stringify(this.dialogImageUrlothers))
        },
        back(){   
            this.oneflag = 1
            console.log(this.oneflag)
             if(this.$route.params.safefails){
                 this.$router.go(-1)
             }else{
                this.one = true
                this.two = false
                this.three = false
                this.four = false
             }
             this.img()
        },
        async back2(){
            if(!this.$route.params.all){
                var {data:dt} = await deleteCode({
                    code:this.codestr
                })
                console.log(dt)
            }
            this.one = false
            this.two = true
            this.three = false
            this.four = false
            this.img()
        },
        img(){
            // 身份证正面
                    console.log(window.localStorage.getItem('A'))
                    this.fileList[0] = {url:window.localStorage.getItem('A')}
                    if(this.fileList.length !== 0){
                        if(this.fileList[0].url !== null){
                            this.hideUpload = true
                             this.dialogImageUrls = this.fileList[0].url
                             this.dialogImageUrl = this.fileList[0].url
                        }else{
                            this.fileList = []
                            this.hideUpload = false
                        }
                    }
                    // 身份证反面
                     this.fileList1[0] = {url:window.localStorage.getItem('B')}
                    if(this.fileList1.length !== 0){
                        if(this.fileList1[0].url !== null){
                            this.hideUploadfan = true
                            this.dialogImageUrlfans = this.fileList1[0].url
                            this.dialogImageUrlfan = this.fileList1[0].url
                        }else{
                            this.fileList1 = []
                            this.hideUploadfan = false
                        }
                    }
                    // 购车发票
                    this.fileList2[0] = {url:window.localStorage.getItem('C')}
                    if(this.fileList2.length !== 0){
                        if(this.fileList2[0].url !== null){
                            this.hideUploadinvoice = true
                            this.dialogImageUrlinvoices = this.fileList2[0].url
                             this.dialogImageUrlinvoice = this.fileList2[0].url
                        }else{
                            this.fileList2 = []
                            this.hideUploadinvoice = false
                        }
                    }
                    // 贷款合同
                    console.log(window.localStorage.getItem('D'))
                     this.fileList3[0] =  {url:window.localStorage.getItem('D')}
                     if(this.fileList3.length !== 0){
                        if(this.fileList3[0].url !== null){
                            this.hideUploadloan = true
                            this.dialogImageUrlloans = this.fileList3[0].url
                            this.dialogImageUrlloan = this.fileList3[0].url
                        }else{
                            this.fileList3 = []
                            this.hideUploadloan = false
                        }
                    }
                    // 行驶证
                     this.fileList4[0] =  {url:window.localStorage.getItem('E')}
                     if(this.fileList4.length !== 0){
                        if(this.fileList4[0].url !== null){
                            this.hideUploadply = true
                            this.dialogImageUrlplys = this.fileList4[0].url
                            this.dialogImageUrlply = this.fileList4[0].url
                        }else{
                            this.fileList4 = []
                            this.hideUploadply = false
                        }
                    }
                    // 合格证
                    this.fileList5[0] =  {url:window.localStorage.getItem('F')}
                    if(this.fileList5.length !== 0){
                        if(this.fileList5[0].url !== null){
                            this.hideUploadqualified = true
                            this.dialogImageUrlqualifieds = this.fileList5[0].url
                            this.dialogImageUrlqualified = this.fileList5[0].url
                        }else{
                            this.fileList5 = []
                            this.hideUploadqualified = false
                        }
                        
                    }
                    // 里程数
                    this.fileList6[0] =  {url:window.localStorage.getItem('G')}
                    if(this.fileList6.length !== 0){
                        if(this.fileList6[0].url !== null){
                             this.hideUploadmileage = true
                             this.dialogImageUrlmileages = this.fileList6[0].url
                             this.dialogImageUrlmileage = this.fileList6[0].url
                        }else{
                            this.fileList6 = []
                            this.hideUploadmileage = false
                        }
                       
                    }

                    // 驾驶证
                    this.fileList8[0] =  {url:window.localStorage.getItem('I')}
                    if(this.fileList8.length !== 0){
                        if(this.fileList8[0].url !== null){
                             this.hideUploaddriveLicence = true
                             this.dialogImageUrldriveLicences = this.fileList8[0].url
                             this.dialogImageUrldriveLicence = this.fileList8[0].url
                        }else{
                            this.fileList8 = []
                            this.hideUploaddriveLicence = false
                        }
                       
                    }
                    //  其他的
                    console.log(JSON.parse(window.localStorage.getItem('H')))
                    if(JSON.parse(window.localStorage.getItem('H'))){
                        let H = JSON.parse(window.localStorage.getItem('H'))
                        this.fileList7 = []
                        H.forEach(item=>{
                            this.fileList7.push({url:item})
                        })
                        console.log(this.fileList7)
                        if(this.fileList7.length !== 0){
                            if(this.fileList7[0].url){
                            this.hideUploadother = true
                            this.dialogImageUrlothers = this.fileList7.map(item=>{
                                return item.url
                            })
                            this.dialogImageUrlother = this.fileList7.map(item=>{
                                console.log(item)
                                return item.url
                            })
                            }else{
                                this.fileList7 = []
                                this.hideUploadother = false
                            }
                        }
                        if(this.fileList7.length >= 6){
                            this.hideUploadother = true
                        }else{
                            this.hideUploadother = false
                        }
                    }     
        },
        async getdata(){
            var {data:dt} = await getproduct({
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.productList = dt.data.list
            }
        },
        carnature(value){
            console.log(value,this.ruleForm.resource)
            if(value == 1){
                this.toggle = true
                this.ruleForm.paperwork = 1
                this.a = true
                this.b = false
                this.c = false
                this.d = false
            }else{
                this.toggle = false
                this.ruleForm.paperwork = 3
                this.a = false
                this.b = false
                this.c = true
                this.d = false
            }
        },
        // 试算保费
        async money(){
            console.log(this.ruleForm.loan,this.ruleForm.years,this.ruleForm.money)
            if(this.flagbuycartype){
                if(this.ruleForm.loan == ''){
                    this.$message.error('请填写贷款金额')
                    return
                }else if(this.ruleForm.years == ''){
                    this.$message.error('请选择保险年限')
                    return
                }else if(this.ruleForm.money == ''){
                    this.$message.error('请填写发票金额')
                }else{
                    console.log(111)
                    var {data:dt} = await trialPremium({
                        id:this.$route.params.safefails?this.$route.params.all.productId:this.productId,
                        shopId:Number(window.localStorage.getItem('shopId')),
                        loanAmount:this.ruleForm.loan,
                        insuranceAge:this.ruleForm.years,
                        invoicePrice:this.ruleForm.money
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.moneys = dt.data.money
                        this.moneysflag = true
                    }else{
                        this.$message.error(dt.message)
                    }
                }
            }else{
                if(this.ruleForm.years == ''){
                    this.$message.error('请选择保险年限')
                    return
                }else if(this.ruleForm.money == ''){
                    this.$message.error('请填写发票金额')
                }else{
                     var {data:dt1} = await trialPremium({
                        id:this.$route.params.safefails?this.$route.params.all.productId:this.productId,
                        shopId:Number(window.localStorage.getItem('shopId')),
                        loanAmount:this.ruleForm.loan,
                        insuranceAge:this.ruleForm.years,
                        invoicePrice:this.ruleForm.money
                    })
                    console.log(dt1)
                     if(dt1.code == 200){
                        this.moneys = dt1.data.money
                        this.moneysflag = true
                    }else{
                        this.$message.error(dt1.message)
                    }
                }
            }
            
        },
        selectdate(value){
            console.log(value,new Date(value),this.ruleForm.date1,this.yearsnum)
            this.buycardate = value
            var curDate = new Date(value);
            var Dates = new Date(curDate.getTime()); //当前天
            var date1 = new Date(Dates)
            var ms = date1.getMonth() + 1
            ms = ms < 10 ? ('0' + ms) : ms
            var ys = date1.getFullYear()
            var ds = date1.getDate()
            ds = ds < 10 ? ('0' + ds) : ds
            let timeinit = ys + '-' + ms + '-' + ds
            this.dateinit = timeinit
            console.log(timeinit)
            var nextDate = new Date(curDate.getTime() + 24*60*60*1000); //后一天
            console.log(nextDate)
            var date = new Date(nextDate)
            var m = date.getMonth() + 1
            m = m < 10 ? ('0' + m) : m
            var d = date.getDate()
            d = d < 10 ? ('0' + d) : d
           if(this.insuranceExtensionType == 0){
                //    非延保类型
                var y = date.getFullYear()
                const time = y + '-' + m + '-' + d
                console.log(time) 
                this.effectivedate = time
           }else{
                // 延保类
                var y1 = date.getFullYear() + Number(this.yearsnum)
                const time = y1 + '-' + m + '-' + d
                console.log(time) 
                this.effectivedate = time
           }
        },
        selectinput(value){
            console.log(value.target.value,this.ruleForm.date1,this.buycardate)
            this.yearsnum = value.target.value
            if(this.buycardate){
                var curDate = new Date(this.buycardate);
            }else{
                var curDate1 = new Date(this.ruleForm.date1);
            }
           
            var nextDate =this.buycardate? new Date(curDate.getTime() + 24*60*60*1000) : new Date(curDate1.getTime() + 24*60*60*1000); //后一天
            console.log(nextDate)
            var date = new Date(nextDate)
            var m = date.getMonth() + 1
            m = m < 10 ? ('0' + m) : m
            var d = date.getDate()
            d = d < 10 ? ('0' + d) : d
            console.log(this.insuranceExtensionType)
             if(this.insuranceExtensionType == 1){
                 var y = date.getFullYear() + Number(value.target.value)
                 console.log(y)
                const time = y + '-' + m + '-' + d
                console.log(time) 
                  this.effectivedate = time
             }else{
                var y1 = date.getFullYear()
                const time = y1 + '-' + m + '-' + d
                console.log(time) 
                this.effectivedate = time
             }
        },
        carryon(){
            location.reload()
            // this.one = true
            // this.two = false
            // this.three = false
            // this.four = false
            // this.draftstate = false 
            // this.draftstate2 = false
            // this.$route.params.all = false
            // this.oneflag = 0
            // console.log(this.$route.params.all)
            // window.localStorage.removeItem('A')
            // window.localStorage.removeItem('B')
            // window.localStorage.removeItem('C')
            // window.localStorage.removeItem('D')
            // window.localStorage.removeItem('E')
            // window.localStorage.removeItem('F')
            // window.localStorage.removeItem('G')
            // window.localStorage.removeItem('H')
            // location.reload()
            // this.$router.replace('/supplierAllBack')
        },
        selectdates(value){
            console.log(value)
        },
        async verifiycode(value){
            console.log(value)
            this.devicevalue = value.target.value
            if(value.target.value !== ''){
                var {data:dt} = await verifyFacility({
                    shopId:window.localStorage.getItem('shopId'),
                    deviceCoding:value.target.value,
                    deviceId:this.deviceid?this.deviceid:this.$route.params.all.deviceId
                })
                console.log(dt)
                if(dt.code !== 200){
                    this.flag = true
                    this.$message.error(dt.message)
                    return
                }else{
                    this.flag = false
                }
            }
        },
        savedraft(){
            this.draftstate = true
            if(this.$route.params.draft){
                        this.draft = this.$route.params.draft  
                    }else{
                        this.draft = false
            }
            this.submitForm2()
        },
        savecaogao(){
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) { 
                    this.draftstate2 = true  
                    if(this.$route.params.draft){
                        this.draft = this.$route.params.draft  
                    }else{
                        this.draft = false
                    }
                    
                 }
                this.submitForm()
            })
                console.log(this.draftstate2)
             
        },
        buytype(value){
            console.log(value)
            if(value == 1){
                this.flagbuycartype = true
                this.ruleForm.loan = ''
                this.ruleForm.loannumber = ''
                this.ruleForm.companyvalue = ''
            }else{
                this.flagbuycartype = false
                this.ruleForm.loan = ''
                this.ruleForm.loannumber = ''
                this.ruleForm.companyvalue = ''
            }
        },
        selectinitdate(value){
            console.log(value)
        },
        paperworktype(value){
            console.log(value)
            if(value == 1){
                this.a = true
                this.b = false
                this.c = false
                this.d = false
                this.ruleForm.number = ''
                this.ruleForm.numberpassport = ''
                this.ruleForm.numbercredit = ''
                this.ruleForm.numberother = ''
            }else if(value == 2){
                this.a = false
                this.b = true
                this.c = false
                this.d = false
                this.ruleForm.number = ''
                this.ruleForm.numberpassport = ''
                this.ruleForm.numbercredit = ''
                this.ruleForm.numberother = ''
            }else if(value == 3){
                this.a = false
                this.b = false
                this.c = true
                this.d = false
                this.ruleForm.number = ''
                this.ruleForm.numberpassport = ''
                this.ruleForm.numbercredit = ''
                this.ruleForm.numberother = ''
            }else if(value == 4){
                this.a = false
                this.b = false
                this.c = false
                this.d = true
                this.ruleForm.number = ''
                this.ruleForm.numberpassport = ''
                this.ruleForm.numbercredit = ''
                this.ruleForm.numberother = ''
            }
        },
        deviceselect(value){
            console.log(value,this.deviceList)
            let id =  this.deviceList.map(item=>{
                if(item.deviceName == value){
                    return item.id
                }
            })
            let arr = []
            id.forEach(item=>{
                if(item !== undefined){
                    arr.push(item)
                }
            })
            console.log(arr)
            this.deviceid = arr.toString()
            console.log(id)
            this.ruleForm.devicenum = ''
        },
        selectcompany(value){
            console.log(value,this.ruleForm.companyvalue)
            
        },
    }
}

</script>
<style lang="less" scoped>
.sell{
    .code_main{
        background: #fff;
        padding: 15px 200px;
        box-sizing: border-box;
        border-right: 5px;
        text-align: center;
        overflow: hidden;
        border-radius: 5px;
        span{
            float: left;
            display: block;
        }
        span:nth-child(1),span:nth-child(5),span:nth-child(7){
            width: 12%;
        }
        span:nth-child(3){
            width: 15%;
            text-align: center;
        }
        span:nth-child(2),span:nth-child(4),span:nth-child(6){
            width: 15%;
            height: 1px;
            background: #000;
            margin-top: 12px;
        }
        .active{
            color: #409eff;
        }
        .install{
            width: 30%!important;
        }
    }
    .productlist{
        margin-top: 15px;
        overflow: hidden;      
        .product{
            cursor: pointer;
            width: 23%;
            margin-right: 2.6%;
            background: #fff;
            border-radius: 1px;
            margin-bottom: 15px;
            float: left;
            .product_top{
                height: 50px;
                line-height: 50px;
                border-bottom: 1px solid #eeeeee;
                padding: 0 15px;
                box-sizing: border-box;
                font-size: 14px;
                span:nth-child(2){
                    float: right;
                    color: #268af0;
                    cursor: pointer;
                }
            }
            .product_year{
                padding: 15px;
                box-sizing: border-box;
                font-size: 14px;
                p:nth-child(1){
                    margin-bottom: 10px;
                }
            }
        } 
        .product:nth-child(4n){
            margin-right: 0;
        }  
    }
    .carownperson{
        background: #fff;
        margin-top: 15px;
        padding: 15px;
        box-sizing: border-box;
        border-radius: 3px;
        .a{
            padding: 30px 0 50px 0;
            border-bottom: 1px solid #409eff;
            overflow: hidden;
            p{
                font-size: 16px;
                color: #409eff;
                font-weight: 700;
                height: 50px;
                line-height: 50px;
                padding: 10px 15px;
            }
            .left{
                float: left;
                width: 48%;
            }
            .right{
                float: right;
                width: 48%;
            }
            .b{
                width: 48%;
                float: left;
                margin-right: 4%;
            }
            .b:nth-child(2n){
                margin-right: 0;
            }
        }
        .a:last-child{
            border-bottom: none;
            text-align: center;
            margin-left: -130px;
        }
    }
    .installinfo{
        background: #fff;
        margin-top: 15px;
        padding: 15px;
        box-sizing: border-box;
        border-radius: 3px;
        .a{
            padding: 30px 0 50px 0;
            border-bottom: 1px solid #409eff;
            overflow: hidden;
            p{
                font-size: 16px;
                color: #409eff;
                font-weight: 700;
                height: 50px;
                line-height: 50px;
                padding: 10px 15px;
            }
            .left{
                float: left;
                width: 48%;
            }
            .right{
                float: right;
                width: 48%;
            }
            .b{
                width: 48%;
                float: left;
                margin-right: 4%;
            }
            .b:nth-child(2n){
                margin-right: 0;
            }
        }
        .a:last-child{
            border-bottom: none;
            text-align: center;
            margin-left: -130px;
        }
    }
    .success{
        background: #fff;
        margin-top: 15px;
        padding: 15px;
        box-sizing: border-box;
        border-radius: 3px;
        text-align: center;
        img{
            margin-top: 180px;
        }
        p{
            font-size: 18px;
            font-weight: 700;
            margin-top: 10px;
        }
        button{
            margin-top: 200px;
            margin-bottom: 50px;
        }
    }
}
</style>
<style>
.hide .el-upload--picture-card {
    display: none;
}
.activeborder{
    border: 2px solid #268af0;
    box-sizing: border-box;
    margin-bottom: 10px!important;
}
</style>